<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 3; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>

    <div class="main-container">
      <div
        v-if="
          !loaderStatus &&
          (!this.particularJob.active ||
            this.particularJob.closed ||
            this.particularJob.status != 3)
        "
        class="
          h-100
          d-flex
          justify-content-center
          align-items-center
          flex-column
        "
      >
        <img src="@/assets/img/newkanban/job-not-found.svg" alt />
        <div class="search-text-no-data">
          {{ getJobNotFoundText }}
        </div>
      </div>
      <template v-else>
        <div
          class="
            dashboardAdmin-header
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <div class="d-flex align-items-center">
            <img
              @click="goBack()"
              src="../../assets/img/feedbackform/backarrow.svg"
              class="pointer"
              alt
            />
            <div
              @click="jobCards.length > 1 ? toggleJobCard() : ''"
              class="
                dashboardAdmin-header-main-head
                ml-2
                position-relative
                pointer
              "
              ref="close-job"
              v-closable="{
                exclude: ['close-job', 'select-job'],
                handler: 'closeJobCard',
              }"
            >
              <span>{{ particularJob.title }}</span>
              <template v-if="jobCards.length > 1">
                <span class="ml-2" v-if="!isJobDropdown">
                  <img
                    src="../../assets/img/newkanban/downsmallarrow.svg"
                    alt
                  />
                </span>
                <span v-else class="ml-2">
                  <img src="../../assets/img/newkanban/upsmallarrow.svg" alt />
                </span>
              </template>
              <div
                class="kanban-job-dd"
                @scroll="onScrollJob"
                ref="select-job"
                v-if="isJobDropdown"
              >
                <div
                  @click="selectJobCard(job)"
                  :class="
                    particularJob.jobID == job.jobID
                      ? 'kanban-job-dd-active'
                      : 'kanban-job-dd-inactive'
                  "
                  v-for="job in jobCards"
                  :key="job.jobID"
                >
                  {{ job.title }}
                </div>
                <div
                  style="margin: auto"
                  v-if="showJobSpinner"
                  class="d-flex justify-content-center mt-2"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
            </div>
            <div
              v-if="particularJob.onHold"
              class="
                on-hold-box
                d-flex
                justify-content-center
                align-items-center
                ml-3
              "
            >
              (On Hold)
            </div>
          </div>
          <div class="d-flex align-items-center" style="gap: 10px">
            <div class="relativeclass bluebtn mr-2">
              <b-button
                :disabled="triggerCVS || sendScreening || triggerReport"
                @click="checkAndApplyGraph()"
                class="acs-addBtn-modal padding-6-19 d-flex align-items-center"
              >
                <img
                  src="../../assets/img/accessconnew/whitePlus.svg"
                  alt
                  class="mr-2"
                />
                <span class>Job Analytics</span>
                <img
                  v-if="!showElement"
                  class="ml-2"
                  src="../../assets/img/whitedownarrow.svg"
                  alt
                />
                <img
                  v-else
                  class="ml-2"
                  src="../../assets/img/whiteuparrow.svg"
                  alt
                />
              </b-button>
            </div>
            <div
              v-if="roles.includes('GET_JOB_STATISTICS')"
              class="d-flex rep-switchParent mr-2"
            >
              <div
                class="switchChild activeSwitchLeft"
                :class="
                  (triggerCVS || sendScreening || triggerReport) &&
                  'disabled-kanban-img'
                "
              >
                <img
                  src="../../assets/New-imgs/landing-dashboard/graph2-w.svg"
                  alt
                />
              </div>
              <div
                class="switchChild notActiveSwitchRight"
                @click="
                  !triggerCVS && !sendScreening && !triggerReport
                    ? gotoAnalytics()
                    : ''
                "
                :class="
                  (triggerCVS || sendScreening || triggerReport) &&
                  'disabled-kanban-img'
                "
              >
                <img
                  src="../../assets/New-imgs/landing-dashboard/graph1-g.svg"
                  alt
                />
              </div>
            </div>
            <div
              v-if="
                roles.includes('PUSH_CANDIDATE') ||
                roles.includes('GET_TALENTPOOL')
              "
              class="relativeclass bluebtn"
              ref="addToggle"
              v-closable="{
                exclude: ['addToggle', 'addToggledropdown'],
                handler: 'hideaddToggle',
              }"
            >
              <b-button
                :disabled="
                  particularJob.onHold ||
                  triggerCVS ||
                  sendScreening ||
                  triggerReport
                "
                @click="
                  !particularJob.onHold &&
                  !triggerCVS &&
                  !sendScreening &&
                  !triggerReport
                    ? ((thirdParty = false),
                      (addCandidateToggle = !addCandidateToggle))
                    : ''
                "
                class="acs-addBtn-modal padding-6-19 d-flex align-items-center"
              >
                <img
                  src="../../assets/img/accessconnew/whitePlus.svg"
                  alt
                  class="mr-2"
                />
                <span class>Add Candidate</span>
                <img
                  v-if="!addCandidateToggle"
                  class="ml-2"
                  src="../../assets/img/whitedownarrow.svg"
                  alt
                />
                <img
                  v-else
                  class="ml-2"
                  src="../../assets/img/whiteuparrow.svg"
                  alt
                />
              </b-button>
              <div
                v-if="addCandidateToggle"
                class="talentPoolcandidateToggle candidate-z-index"
              >
                <div
                  v-if="roles.includes('PUSH_CANDIDATE')"
                  class="pointer unselOption"
                  @click="goToAddCandidate()"
                >
                  <img
                    class="mr-2"
                    src="../../assets/talentpool/boldPlus.svg"
                    alt
                  />
                  Add New Candidate
                </div>
                <div
                  v-if="roles.includes('GET_TALENTPOOL')"
                  class="pointer unselOption"
                  @click="showTalentPool = true"
                >
                  <img
                    class="mr-2"
                    src="../../assets/talentpool/boldPlus.svg"
                    alt
                  />
                  Add From Talent Pool
                </div>
                <div
                  v-if="roles.includes('PUSH_CANDIDATE')"
                  class="pointer unselOption"
                  @click="addMultipleCandidates = true"
                >
                  <img
                    class="mr-2"
                    src="../../assets/talentpool/mulCand.svg"
                    alt
                  />
                  Add Multiple Candidates
                </div>

                <div
                  v-if="
                    checkThirdPartyAccess && roles.includes('GET_CV_SEARCH')
                  "
                  class="
                    pointer
                    position-relative
                    d-flex
                    justify-content-between
                  "
                  @click="thirdParty = !thirdParty"
                  :class="
                    thirdParty
                      ? 'talentpool-thirdparty-sel'
                      : 'talentpool-thirdparty-unsel'
                  "
                >
                  Add from Third Party
                  <img src="../../assets/talentpool/rightArrow.svg" alt />
                  <div class="tp-thirdparty-drop h-100" v-if="thirdParty">
                    <div
                      @click.stop="goToCVSearch('kanbanView')"
                      class="d-flex align-items-center h-100 p-1"
                    >
                      CV Search
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-button
              :disabled="
                particularJob.onHold ||
                triggerCVS ||
                sendScreening ||
                triggerReport
              "
              @click="
                !particularJob.onHold &&
                !triggerCVS &&
                !sendScreening &&
                !triggerReport
                  ? exportCandidates()
                  : ''
              "
              v-b-tooltip.hover.bottom="'Export Candidates'"
              class="
                round-btn-set
                d-flex
                justify-content-center
                align-items-center
              "
            >
              <img src="@/assets/img/newkanban/export-btn-excel.svg" alt />
            </b-button>
          </div>
        </div>
        <!-- <template v-if="jobAnalytics"> -->
        <!-- v-show="showElement" -->

        <div
          v-show="showElement"
          class="mt-12px job-analytics-container"
          :class="{ 'fade-in': jobAnalytics, 'fade-out': !jobAnalytics }"
        >
          <div
            style="margin: auto"
            v-if="funnelLoader"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <template v-else>
            <div class="d-flex w-100 h-100">
              <div style="width: 90%; height: 100%" id="funnel"></div>
              <div class="funnelgraph-detail-container" style="width: 15%">
                <div class="app-container">
                  Total Applicants:
                  <span class="funnel-onhold-numbertxt">
                    {{ jobStats.applied ? jobStats.applied : 0 }}
                  </span>
                </div>
                <div class="d-flex align-items-center flex-column mt-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <img src="../../assets/ReportsNew/funnelonhold.svg" alt />
                    </div>
                    <div class="funnel-onhold-numbertxt pt-1 pl-1">
                      {{
                        jobStatsData.onHoldCount ? jobStatsData.onHoldCount : 0
                      }}
                    </div>
                  </div>
                  <div class="funnel-onhold-text" style="font-weight: 600">
                    On Hold
                  </div>
                </div>
                <hr class="m-2 w-100" />
                <div class="d-flex align-items-center flex-column">
                  <div class="d-flex align-items-center">
                    <div>
                      <img
                        src="../../assets/ReportsNew/funnelrejected.svg"
                        alt
                      />
                    </div>
                    <div class="funnel-onhold-numbertxt pt-1 pl-1">
                      {{
                        jobStatsData.rejectedCount
                          ? jobStatsData.rejectedCount
                          : 0
                      }}
                    </div>
                  </div>

                  <div class="funnel-onhold-text" style="font-weight: 600">
                    Rejected
                  </div>
                </div>
                <hr class="m-2 w-100" />
                <div class="d-flex align-items-center flex-column">
                  <div class="d-flex align-items-center">
                    <div>
                      <img src="../../assets/ReportsNew/funnelni.svg" alt />
                    </div>
                    <div class="funnel-onhold-numbertxt pt-1 pl-1">
                      {{
                        jobStatsData.notInterestedCount
                          ? jobStatsData.notInterestedCount
                          : 0
                      }}
                    </div>
                  </div>
                  <div class="funnel-onhold-text" style="font-weight: 600">
                    Not interested
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- </template> -->
        <div class="blur-overlay" v-if="showBlur"></div>
        <div
          class="mt-2"
          :class="
            showElement
              ? 'kanban-job-new-maincontainer'
              : 'kanban-new-maincontainer'
          "
        >
          <div
            class="
              position-relative
              px-4
              pt-3
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <div class="kanban-new-heading">Kanban</div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <div class="mx-2 d-flex">
                  <div class="d-flex flex-column justify-content-center">
                    <img
                      v-if="particularJob.automatic"
                      class="mr-2 mt-1"
                      height="14"
                      width="18"
                      src="../../assets/img/newkanban/AI-icon.svg"
                      alt
                    />
                  </div>
                  <div>
                    <div
                      class="kanban-onhold-text"
                      :class="!lowCredits && 'mt-1'"
                      v-if="particularJob.automatic"
                    >
                      Automated Job
                    </div>
                    <div
                      v-if="lowCredits"
                      @click="
                        roles.includes('HIRE3X_WALLET') ? goToCredits() : ''
                      "
                      class="d-flex justify-content-between"
                      :class="!particularJob.automatic && 'gap-10 mt-1'"
                    >
                      <div
                        class="kanban-onhold-text"
                        style="color: #eb0002 !important"
                      >
                        Low Credits!
                      </div>
                      <img
                        v-if="roles.includes('HIRE3X_WALLET')"
                        class="pointer"
                        src="../../assets/img/newkanban/lowcredits-arrow.svg"
                        alt
                      />
                    </div>
                  </div>
                  <div
                    v-if="lowCredits"
                    class="d-flex flex-column justify-content-center ml-2"
                  >
                    <div class="line-row mx-2"></div>
                  </div>
                </div>
                <div
                  v-if="roles.includes('SEND_SCREENING')"
                  class="
                    pointer
                    main-share-txt
                    screening-share-txt
                    d-flex
                    align-items-center
                    bluebtn
                    mx-2
                  "
                  :class="{
                    expanded: screening || sendScreening,
                    'disabled-kanban-img':
                      particularJob.onHold || triggerCVS || triggerReport,
                  }"
                  @mouseenter="
                    !particularJob.onHold &&
                      !triggerCVS &&
                      !triggerReport &&
                      showScreening()
                  "
                  @mouseleave="
                    !particularJob.onHold &&
                      !triggerCVS &&
                      !triggerReport &&
                      hideScreening()
                  "
                >
                  <div class="share-hv">
                    <img
                      src="../../assets/img/newkanban/send-screeing-btn.svg"
                      alt=""
                    />
                  </div>

                  <b-button
                    v-if="screening || sendScreening"
                    class="acs-addBtn-modal w-100"
                    style="height: 29px"
                    @click="
                      !sendScreening && screening
                        ? ((sendScreening = true),
                          (showElement = false),
                          (jobAnalytics = false))
                        : ''
                    "
                  >
                    <template>
                      <div
                        @click="
                          sendScreening &&
                          triggerCands.length != 0 &&
                          !triggerCVSPost
                            ? sendCandForScreening()
                            : ''
                        "
                        class="mr-2"
                        :class="{
                          'disabled-kanban-img':
                            (sendScreening && triggerCands.length == 0) ||
                            triggerCVSPost,
                        }"
                      >
                        <img
                          class="pb-1"
                          src="../../assets/img/newkanban/send-screening-icon.svg"
                          alt=""
                        />
                      </div>

                      <div
                        :class="{
                          'disabled-kanban-img':
                            (sendScreening && triggerCands.length == 0) ||
                            triggerCVSPost,
                        }"
                        @click="
                          sendScreening &&
                          triggerCands.length != 0 &&
                          !triggerCVSPost
                            ? sendCandForScreening()
                            : ''
                        "
                      >
                        Send for Screening
                      </div>
                    </template>
                    <template v-if="sendScreening">
                      <div @click="closeScreening()" class="mx-2">
                        <img
                          src="./../../assets/img/trigger-white-line.svg"
                          alt=""
                        />
                      </div>
                      <div @click="closeScreening()">
                        <img
                          src="./../../assets/img/trigger-white-crossicon.svg"
                          alt=""
                        />
                      </div>
                    </template>
                  </b-button>
                </div>

                <div
                  v-if="roles.includes('TRIGGER_CVS')"
                  class="
                    pointer
                    main-share-txt
                    d-flex
                    align-items-center
                    bluebtn
                    mx-2
                  "
                  :class="{
                    expanded: cvs || triggerCVS,
                    'disabled-kanban-img':
                      particularJob.onHold || sendScreening || triggerReport,
                  }"
                  @mouseenter="
                    !particularJob.onHold &&
                      !sendScreening &&
                      !triggerReport &&
                      showCVS()
                  "
                  @mouseleave="
                    !particularJob.onHold &&
                      !sendScreening &&
                      !triggerReport &&
                      hideCVS()
                  "
                >
                  <div class="share-hv">
                    <img src="../../assets/img/trigger-CVS-icon.svg" alt />
                  </div>

                  <b-button
                    v-if="cvs || triggerCVS"
                    class="acs-addBtn-modal w-100"
                    style="height: 29px"
                    @click="
                      !triggerCVS && cvs
                        ? ((triggerCVS = true),
                          (showElement = false),
                          (jobAnalytics = false))
                        : ''
                    "
                  >
                    <template>
                      <div
                        @click="
                          triggerCVS &&
                          triggerCands.length != 0 &&
                          !triggerCVSPost
                            ? triggerCVSForCands()
                            : ''
                        "
                        class="mx-2"
                        :class="{
                          'disabled-kanban-img':
                            (triggerCVS && triggerCands.length == 0) ||
                            triggerCVSPost,
                        }"
                      >
                        <img
                          class="pb-1"
                          src="./../../assets/img/trigger-btn-icon.svg"
                          alt
                        />
                      </div>

                      <div
                        :class="{
                          'disabled-kanban-img':
                            (triggerCVS && triggerCands.length == 0) ||
                            triggerCVSPost,
                        }"
                        @click="
                          triggerCVS &&
                          triggerCands.length != 0 &&
                          !triggerCVSPost
                            ? triggerCVSForCands()
                            : ''
                        "
                      >
                        Trigger CVS
                      </div>
                    </template>
                    <template v-if="triggerCVS">
                      <div @click="closeTrigger()" class="mx-2">
                        <img
                          src="./../../assets/img/trigger-white-line.svg"
                          alt
                        />
                      </div>
                      <div @click="closeTrigger()">
                        <img
                          src="./../../assets/img/trigger-white-crossicon.svg"
                          alt
                        />
                      </div>
                    </template>
                  </b-button>
                </div>

                <div
                  class="
                    pointer
                    main-share-txt
                    report-share-txt
                    d-flex
                    align-items-center
                    bluebtn
                    mx-2
                  "
                  :class="{
                    expanded: report || triggerReport,
                    'disabled-kanban-img':
                      particularJob.onHold || triggerCVS || sendScreening,
                  }"
                  @mouseenter="
                    !particularJob.onHold &&
                      !triggerCVS &&
                      !sendScreening &&
                      showReport()
                  "
                  @mouseleave="
                    !particularJob.onHold &&
                      !triggerCVS &&
                      !sendScreening &&
                      hideReport()
                  "
                >
                  <div class="share-hv">
                    <img
                      src="../../assets/new-kanban-icons/generate-report.svg"
                      alt
                      width="32"
                      height="32"
                    />
                  </div>

                  <b-button
                    v-if="report || triggerReport"
                    class="acs-addBtn-modal w-100"
                    style="height: 29px"
                    @click="
                      !triggerReport && report
                        ? ((triggerReport = true),
                          (showElement = false),
                          (jobAnalytics = false))
                        : ''
                    "
                  >
                    <template>
                      <div
                        @click="
                          triggerReport &&
                          triggerCands.length != 0 &&
                          !triggerReportPost
                            ? triggerReportForCands()
                            : ''
                        "
                        class="mx-2"
                        :class="{
                          'disabled-kanban-img':
                            (triggerReport && triggerCands.length == 0) ||
                            triggerReportPost,
                        }"
                      >
                        <img
                          class="pb-1"
                          src="../../assets/new-kanban-icons/generate-report.svg"
                          alt
                          width="32"
                          height="32"
                        />
                      </div>

                      <div
                        :class="{
                          'disabled-kanban-img':
                            (triggerReport && triggerCands.length == 0) ||
                            triggerReportPost,
                        }"
                        @click="
                          triggerReport &&
                          triggerCands.length != 0 &&
                          !triggerReportPost
                            ? triggerReportForCands()
                            : ''
                        "
                      >
                        Generate Report
                      </div>
                    </template>
                    <template v-if="triggerReport">
                      <div @click="closeReport()" class="mx-2">
                        <img
                          src="./../../assets/img/trigger-white-line.svg"
                          alt
                        />
                      </div>
                      <div @click="closeReport()">
                        <img
                          src="./../../assets/img/trigger-white-crossicon.svg"
                          alt
                        />
                      </div>
                    </template>
                  </b-button>
                </div>

                <div
                  class="position-relative mr-4 pointer bluebtn mx-2"
                  @click="refreshKanban()"
                >
                  <img
                    src="../../assets/new-kanban-icons/refreshBlog.svg"
                    alt
                    width="32"
                    height="32"
                  />
                </div>

                <div class="bluebtn position-relative">
                  <b-button
                    class="acs-addBtn"
                    @click="showFilter()"
                    ref="openCard"
                    ><img
                      class="mr-2"
                      src="../../assets/img/accessconnew/whiteFilter.svg"
                      alt
                    />Filter
                  </b-button>
                  <div
                    style="left: 25px; top: 8px"
                    class="kanban-filter-count mb-3"
                    v-if="filterApplied"
                  ></div>
                  <div
                    v-if="isFilter"
                    class="acs-filter p-3"
                    style="width: 305px; top: 35px; right: 0"
                    ref="closeCard"
                  >
                    <div>
                      <div class="filter-inner">
                        <div @click.stop="" class="topDiv">
                          <DateField
                            format="YYYY-MM-DD"
                            type="date"
                            :vmodel="filterObject.selectedDate"
                            :label="'Added At'"
                            placeholder="Select date range"
                            id="date-filter-range"
                            :range="true"
                            @select-value="filterObject.selectedDate = $event"
                          />
                        </div>
                        <div class="mt-2">
                          <Sourcemulti
                            :from="'scroll-filter'"
                            :label="'Source'"
                            :placeholder="'Select Source'"
                            :vmodel="filterObject.filterSource"
                            :id="'kanbansource'"
                            :showThirdParty="true"
                            @setValue="filterObject.filterSource = $event"
                          />
                        </div>
                        <div class="topDiv mt-2" @click.stop="">
                          <FormTags
                            :label="'Skills'"
                            :mandatory="false"
                            :placeholder="'Enter Skills'"
                            :id="'kanbanskills'"
                            @select-value="filterObject.skillSets = $event"
                            :vmodel="filterObject.skillSets"
                          />
                        </div>
                        <div class="topDiv">
                          <AddedByUsers
                            :from="'scroll-filter'"
                            :placeholder="'Select'"
                            :label="'Position IDs'"
                            :id="'kanbanpositionID'"
                            :vmodel="filterObject.positionID"
                            :positionIDs="positionFilters"
                            @setValue="filterObject.positionID = $event"
                          />
                        </div>
                        <div v-if="getCustomerDetail.lead">
                          <AddedByUsers
                            :from="'scroll-filter'"
                            :placeholder="'Select'"
                            :label="'Added By'"
                            :id="'kanbanfilter'"
                            :jobID="particularJob.jobID"
                            :vmodel="filterObject.createdByUserName"
                            @setValue="filterObject.createdByUserName = $event"
                          />
                        </div>
                        <div class="topDiv mt-2">
                          <SelectCustom
                            :from="'scroll-filter'"
                            :placeholder="'Select'"
                            :id="'cvsStatus'"
                            type="filter"
                            :values="cvsStatusValues"
                            :dropdown="true"
                            @select-value="filterObject.cvsStatus = $event"
                            :vmodel="filterObject.cvsStatus"
                            :label="'CVS Status'"
                          />
                        </div>
                        <div
                          v-if="notesTags.length != 0"
                          class="topDiv mt-2 mb-2"
                        >
                          <MultiSearch
                            :label="'Assigned Tags'"
                            :placeholder="'Select'"
                            :dropdown="{
                              options: notesTags,
                              searchType: 'local',
                            }"
                            :vmodel="filterObject.tags"
                            @select-value="filterObject.tags = $event"
                          />
                        </div>
                      </div>
                      <div class="d-flex justify-content-between mt-3 bluebtn">
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="cancelFilter()"
                          >Cancel</b-button
                        >
                        <div class="d-flex">
                          <b-button
                            class="acs-cancelBtn-filter mr-3"
                            :disabled="disableApplyFilter"
                            @click="
                              disableApplyFilter && filterApplied == false
                                ? ''
                                : filterApplied == false
                                ? clearfilter(false)
                                : clearfilter(true)
                            "
                            >Reset</b-button
                          >
                          <b-button
                            :disabled="
                              disableApplyFilter && filterApplied == false
                            "
                            class="acs-cancelBtn-filter"
                            @click="applyTalentFilterTest()"
                            >Apply</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="
              px-3
              py-3
              d-flex
              align-items-center
              gap-15
              w-100
              overflow-auto
              relativeclass
            "
            :style="
              showElement
                ? 'height: calc(-480px + 100vh);'
                : 'height: calc(100vh - 225px)'
            "
            id="mainkanban"
          >
            <div
              class="kanban-card-container py-1"
              style="flex-basis: 130px"
              v-if="!applyContainers && !loaderStatus"
            >
              <template>
                <div
                  class="kanban-card-header mx-1 d-flex align-items-center"
                  style="border-bottom: 3px solid #20639b"
                >
                  <!-- bind this w-75 wen filter n other icon is ter when no icons comes bind the class as w-90 -->
                  <div
                    class="
                      d-flex
                      align-items-center
                      w-100
                      justify-content-center
                    "
                  >
                    <div class="kanban-card-header-text mt-1">Applications</div>
                  </div>
                </div>
                <template>
                  <div
                    class="relativeclass"
                    :style="
                      showElement
                        ? 'height: calc(100% - 60px);'
                        : 'height: calc(100vh - 330px);'
                    "
                  >
                    <div class="fix-right-icon h-100">
                      <img
                        class="pointer"
                        src="../../assets/new-kanban-icons/right-arrow.svg"
                        @click="applyContainers = true"
                        alt
                      />
                    </div>
                    <div class="overflow-auto my-1 h-100">
                      <div class="px-3">
                        <Application :jobStats="jobStats" />
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </div>

            <Transition name="kanban-card-transition" tag="div">
              <div
                v-if="
                  (particularJob.openToPublic || totalApplications != 0) &&
                  applyContainers
                "
                class="d-flex gap-15 kanban-card-container-transition"
                :style="
                  showElement
                    ? 'height: calc(-517px + 100vh);'
                    : 'height: calc(100vh - 263px)'
                "
              >
                <div
                  class="kanban-card-container py-1"
                  style="flex-basis: unset; width: 330px"
                  v-for="appl in Object.keys(applicationData)"
                  :key="appl"
                >
                  <template>
                    <div
                      class="kanban-card-header mx-1 d-flex align-items-center"
                      :style="
                        appl == 'QA'
                          ? 'border-bottom: 3px solid #269C8A'
                          : appl == 'RAI'
                          ? 'border-bottom: 3px solid #AD1927'
                          : 'border-bottom: 3px solid #20639b'
                      "
                    >
                      <div class="d-flex align-items-center w-100">
                        <div class="kanban-card-header-text mt-1">
                          <img
                            v-if="appl == 'QA'"
                            src="../../assets/img/newkanban/mainselected.svg"
                            alt
                          />
                          <img
                            v-else-if="appl == 'RAI'"
                            src="../../assets/img/newkanban/mainrejected.svg"
                            alt
                          />
                          {{
                            appl == "AP"
                              ? "Applied"
                              : appl == "QA"
                              ? "Qualified"
                              : "Screening Reject"
                          }}
                        </div>
                      </div>
                      <div
                        v-if="appl == 'QA' && checkRoundAssessment(0)"
                        class="position-relative"
                        :class="
                          isSchedule ||
                          viewCandidateModal ||
                          showPlatformModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? 'disabled-kanban-img'
                            : 'pointer'
                        "
                        @click="
                          isSchedule ||
                          viewCandidateModal ||
                          showPlatformModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? ''
                            : triggerMultiple()
                        "
                      >
                        <img src="../../assets/img/newkanban/asmnt.svg" alt />
                      </div>
                      <!-- <div
                        v-if="appl == 'QA'"
                        v-b-tooltip.hover.bottom="
                          isSchedule ||
                          viewCandidateModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? ''
                            : 'Refresh'
                        "
                        class="position-relative mr-1"
                        :class="
                          isSchedule ||
                          viewCandidateModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? 'disabled-kanban-img'
                            : 'pointer'
                        "
                        @click="
                          isSchedule ||
                          viewCandidateModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? ''
                            : getQualifiedCands()
                        "
                      >
                        <img
                          src="../../assets/new-kanban-icons/refreshBlog.svg"
                          alt
                        />
                      </div> -->
                      <!-- <div
                        v-else-if="appl == 'RAI'"
                        v-b-tooltip.hover.bottom="
                          isSchedule ||
                          viewCandidateModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? ''
                            : 'Refresh'
                        "
                        class="position-relative mr-1"
                        :class="
                          isSchedule ||
                          viewCandidateModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? 'disabled-kanban-img'
                            : 'pointer'
                        "
                        @click="
                          isSchedule ||
                          viewCandidateModal ||
                          particularJob.onHold ||
                          triggerCVS ||
                          sendScreening ||
                          applicationData[appl].appTotal == 0
                            ? ''
                            : getRejectedCands()
                        "
                      >
                        <img
                          src="../../assets/new-kanban-icons/refreshBlog.svg"
                          alt
                        />
                      </div> -->
                      <div class="kanban-card-header-number">
                        {{ applicationData[appl].appTotal }}
                      </div>
                    </div>
                    <div
                      v-if="applicationData[appl].applSpinner"
                      class="d-flex align-items-center h-80 mt-2"
                    >
                      <SmallSpinner />
                    </div>
                    <template v-else>
                      <div
                        class="relativeclass"
                        :style="
                          showElement
                            ? 'height: calc(100% - 60px);'
                            : 'height: calc(100vh - 330px);'
                        "
                      >
                        <div
                          v-if="appl == 'RAI'"
                          class="fix-right-icon h-100 zindex-3"
                        >
                          <img
                            class="pointer"
                            @click="applyContainers = false"
                            src="../../assets/new-kanban-icons/left-arrow.svg"
                            alt
                          />
                        </div>
                        <div
                          class="overflow-auto my-1 h-100 position-relative"
                          @scroll="onScrollApplCandidates(appl, $event)"
                        >
                          <div
                            v-if="
                              appl == 'QA' &&
                              suggestedCandidates &&
                              suggestedCandidates.length > 0
                            "
                            class="pl-3 pr-12px py-2 position-relative"
                            style="z-index: 2"
                          >
                            <div
                              @click="
                                isSchedule ||
                                viewCandidateModal ||
                                showPlatformModal
                                  ? ''
                                  : openPlatformModal()
                              "
                              class="
                                suggested-card
                                w-100
                                d-flex
                                align-items-center
                                justify-content-between
                              "
                              :class="
                                (isSchedule ||
                                  viewCandidateModal ||
                                  showPlatformModal) &&
                                'disabled-kanban-img'
                              "
                            >
                              <div
                                class="
                                  fs-14
                                  font-lato
                                  fw-600
                                  font-italic
                                  color-white
                                  d-flex
                                  align-items-center
                                "
                              >
                                <img
                                  src="../../assets/img/roundedh3xlogo.svg"
                                  class="mr-2"
                                  alt=""
                                />
                                Suggested Candidates
                              </div>
                              <img
                                src="../../assets/img/suggestedarw.svg"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            v-if="
                              applicationData[appl].applications.length == 0
                            "
                            class="
                              h-100
                              d-flex
                              align-items-center
                              justify-content-center
                              flex-column
                            "
                            :class="{
                              'position-absolute w-100':
                                appl == 'QA' &&
                                suggestedCandidates &&
                                suggestedCandidates.length > 0,
                            }"
                            :style="
                              appl == 'QA' &&
                              suggestedCandidates &&
                              suggestedCandidates.length > 0
                                ? 'top: 0; left: 0; pointer-events: none;'
                                : ''
                            "
                          >
                            <div>
                              <img
                                v-if="
                                  appl == 'QA' &&
                                  !particularJob.manualReview &&
                                  particularJob.automatic
                                "
                                src="../../assets/img/newkanban/automatic-round.svg"
                                alt
                              />

                              <img
                                v-else
                                src="../../assets/img/newvendorflow/emptyapplication.svg"
                                alt
                              />
                            </div>
                            <div
                              class="automated-txt"
                              v-if="
                                appl == 'QA' &&
                                !particularJob.manualReview &&
                                particularJob.automatic
                              "
                            >
                              Candidates Moved to First Round as this job is
                              automated
                            </div>
                            <div v-else class="emptyround-txt-kanban">
                              {{
                                searchQuery != "" && searchQuery != "Loader"
                                  ? `No results for "${searchQuery}"`
                                  : "Currently, there are no applications"
                              }}
                            </div>
                          </div>
                          <div
                            class="px-3 py-2"
                            v-for="candidate in applicationData[appl]
                              .applications"
                            :key="candidate.candidateID"
                          >
                            <!-- <div
                            v-if="appl == 'QA' && index == 0"
                            class="application-cards px-3 py-2 mt-0 mb-2"
                            style="width: 300px"
                          >
                            <div
                              class="
                                d-flex
                                align-items-center
                                justify-content-between
                                w-100
                              "
                            >
                              <div>
                                <img
                                  src="../../assets/new-kanban-icons/AI-icon.svg"
                                  alt=""
                                />
                              </div>
                              <div>
                                <img
                                  class="pointer"
                                  src="../../assets/new-kanban-icons/expand-icon.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                            <div class="ai-number-font mt-1">
                              80/100 Applicants sorted
                            </div>
                            <div class="common-progress-bar mt-1">
                              <b-progress
                                :value="40"
                                :max="100"
                                class="w-100"
                              ></b-progress>
                            </div>
                        </div>-->

                            <Applied
                              v-if="appl == 'AP'"
                              :particularJob="particularJob"
                              :candidate="candidate"
                              :selectedID="selectedID"
                              :isSchedule="
                                isSchedule ||
                                viewCandidateModal ||
                                showPlatformModal
                              "
                              :jobOnHold="
                                particularJob.onHold ||
                                triggerCVS ||
                                sendScreening
                              "
                              :process="interviewProcess[0]"
                              :selectedCandidate="selectedCandidate"
                              :viewCandidateModal="openPreview"
                              :tagFiltered="
                                filterApplied && storeFilterTags.length != 0
                              "
                              :hoverCand="hoverCand"
                              @select-cand="selCandidate($event)"
                              @upload-resume="
                                addAttachment(candidate),
                                  (uploadingResume = true)
                              "
                              @show-blur="showBlurCand($event, candidate)"
                              @view-preview="viewApplCandidate(candidate)"
                            />

                            <Qualified
                              v-else-if="appl == 'QA'"
                              :particularJob="particularJob"
                              :candidate="candidate"
                              :selectedID="selectedID"
                              :isSchedule="
                                isSchedule ||
                                viewCandidateModal ||
                                showPlatformModal
                              "
                              :jobOnHold="
                                particularJob.onHold ||
                                triggerCVS ||
                                sendScreening ||
                                triggerReport
                              "
                              :process="interviewProcess[0]"
                              :selectedCandidate="selectedCandidate"
                              :viewCandidateModal="viewCandidateModal"
                              :triggerCVS="triggerCVS"
                              :triggerCands="triggerCands"
                              :sendScreening="sendScreening"
                              :triggerReport="triggerReport"
                              :tagFiltered="
                                filterApplied && storeFilterTags.length != 0
                              "
                              :hoverCand="hoverCand"
                              @show-blur="showBlurCand($event, candidate)"
                              @re-assign="reAssignModal(candidate)"
                              @trigger-cvs-cand="
                                addCandToTriggerCVS(candidate.candidateID)
                              "
                              @trigger-report-cand="
                                addCandToTriggerCVS(candidate.candidateID)
                              "
                              @not-interested="notIntModal(candidate)"
                              @trigger-assessment="
                                triggerAssessModal(
                                  candidate,
                                  interviewProcess[0],
                                  'fromadd'
                                )
                              "
                              @moveto-first="moveToFirstRound(candidate)"
                              @schedule-interview="scheduleModal(candidate)"
                              @select-cand="selCandidate($event)"
                              @view-candidate="viewCandidate(candidate, $event)"
                              @view-report="viewCandidateReport(candidate)"
                              @change-position="showAssignModal(candidate)"
                              @update-details="
                                getAllApplications(true),
                                  getParticularJob(particularJob.jobID)
                              "
                            />
                            <KanbanRejected
                              v-else-if="appl == 'RAI'"
                              :triggerReport="triggerReport"
                              @trigger-report-cand="
                                addCandToTriggerCVS(candidate.candidateID)
                              "
                              :candidate="candidate"
                              :selectedID="selectedID"
                              :particularJob="particularJob"
                              :isSchedule="
                                isSchedule ||
                                viewCandidateModal ||
                                showPlatformModal
                              "
                              :jobOnHold="
                                particularJob.onHold ||
                                triggerCVS ||
                                sendScreening ||
                                triggerReport
                              "
                              :selectedCandidate="selectedCandidate"
                              :viewCandidateModal="viewCandidateModal"
                              :triggerCVS="triggerCVS"
                              :triggerCands="triggerCands"
                              :sendScreening="sendScreening"
                              :tagFiltered="
                                filterApplied && storeFilterTags.length != 0
                              "
                              :hoverCand="hoverCand"
                              @show-blur="showBlurCand($event, candidate)"
                              @re-analyze="
                                reAanalyzeCand(candidate.candidateID)
                              "
                              @trigger-cvs-cand="
                                addCandToTriggerCVS(candidate.candidateID)
                              "
                              @select-cand="selCandidate($event)"
                              @re-assign="reAssignModal(candidate)"
                              @view-candidate="viewCandidate(candidate, $event)"
                              @update-details="
                                getAllApplications(true),
                                  getParticularJob(particularJob.jobID)
                              "
                            />
                          </div>
                          <div
                            class="text-center"
                            v-if="applicationData[appl].showApplLoader"
                          >
                            <b-spinner class="ml-auto"></b-spinner>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </Transition>

            <div
              class="kanban-card-container py-1"
              v-for="(process, index) in interviewProcess"
              :key="process.id"
            >
              <template>
                <div
                  class="kanban-card-header mx-1 d-flex align-items-center"
                  :style="
                    process.id == 'H'
                      ? 'border-bottom: 3px solid #ffc145'
                      : process.id == 'R'
                      ? 'border-bottom: 3px solid #AD1927'
                      : process.id == 'NI'
                      ? 'border-bottom: 3px solid #595959'
                      : process.id == 'F'
                      ? 'border-bottom: 3px solid #269C8A'
                      : 'border-bottom:3px solid #20639b'
                  "
                >
                  <!-- bind this w-75 wen filter n other icon is ter when no icons comes bind the class as w-90 -->
                  <div
                    class="d-flex align-items-center"
                    v-if="!process.type"
                    :class="{
                      'd-flex': process.id != 0,
                      'align-items-center': process.id != 0,
                      'w-90':
                        !isAsmntIcon(process, index) && !isFilterIcon(process),
                      'w-75':
                        isAsmntIcon(process, index) || isFilterIcon(process),
                    }"
                  >
                    <div class="mr-1" v-if="process.id != 0">
                      <img :src="getRoundSrc(process.id)" alt />
                    </div>
                    <div class="kanban-card-header-text mt-1">
                      {{ getColHeading(process) }}
                    </div>
                  </div>
                  <div class="w-75" v-else>
                    <div class="kanban-main-cards-head-type">
                      {{ getColHeading(process) }}
                    </div>
                    <div
                      class="kanban-card-header-text mt-1 text-truncate"
                      style="width: 190px"
                    >
                      <span
                        style="min-width: auto; max-width: 100"
                        v-b-tooltip.hover="process.name"
                        >{{ process.name }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="isAsmntIcon(process, index)"
                    @click="
                      (roundDetails[`round${process.id}`] &&
                        roundDetails[`round${process.id}`].candidates.length ==
                          0) ||
                      isSchedule ||
                      showPlatformModal ||
                      viewCandidateModal ||
                      particularJob.onHold ||
                      triggerCVS ||
                      sendScreening
                        ? ''
                        : triggerMultiple(process, index)
                    "
                    :class="
                      (roundDetails[`round${process.id}`] &&
                        roundDetails[`round${process.id}`].candidates.length ==
                          0) ||
                      isSchedule ||
                      showPlatformModal ||
                      viewCandidateModal ||
                      particularJob.onHold ||
                      sendScreening ||
                      triggerCVS ||
                      sendScreening
                        ? 'disabled-kanban-img'
                        : 'pointer'
                    "
                  >
                    <img src="../../assets/img/newkanban/asmnt.svg" alt />
                  </div>
                  <div
                    class="position-relative unique-filter-id"
                    :class="'unique-filter-id-' + process.id"
                    v-if="isFilterIcon(process)"
                  >
                    <img
                      :class="
                        (roundDetails[`round${process.id}`] &&
                          roundDetails[`round${process.id}`].candidates
                            .length == 0 &&
                          !uniqueFilter[process.id].filterApplied) ||
                        isSchedule ||
                        showPlatformModal ||
                        viewCandidateModal
                          ? 'disabled-kanban-img'
                          : 'pointer'
                      "
                      src="../../assets/img/newkanban/filter.svg"
                      alt
                      @click="
                        (roundDetails[`round${process.id}`].candidates.length ==
                          0 &&
                          !uniqueFilter[process.id].filterApplied) ||
                        isSchedule ||
                        showPlatformModal ||
                        viewCandidateModal
                          ? ''
                          : showUniqueFilter(process, index)
                      "
                    />
                    <div
                      class="kanban-filter-count mb-3"
                      v-if="uniqueFilter[process.id].filterApplied"
                    ></div>
                    <div
                      v-if="uniqueFilter[process.id].showFilter"
                      class="acs-filter p-3"
                      style="width: 287px; top: 35px; right: -10px"
                    >
                      <div>
                        <div class="teams-label-font mb-2">Filter By</div>
                        <!-- class="filter-inner" -->
                        <template v-if="process.id == 'F'">
                          <div class="allocateradios">
                            <b-form-group>
                              <b-form-radio-group
                                id="radio-group-1"
                                v-model="uniqueFilter[process.id].filterType"
                                :options="statusFilterOptions"
                                value-field="key"
                                text-field="label"
                                name="radio-options"
                                @change="$forceUpdate()"
                                stacked
                              ></b-form-radio-group>
                            </b-form-group>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="topDiv mt-2"
                            v-if="
                              process.type == 'assesment' &&
                              process.selectedtests.length > 1
                            "
                          >
                            <SelectCustom
                              :from="'scroll-filter'"
                              :placeholder="'Select'"
                              type="filter"
                              :id="'kanban-unique'"
                              :values="testData(process)"
                              :dropdown="true"
                              @select-value="
                                (uniqueFilter[process.id].testID = $event),
                                  $forceUpdate()
                              "
                              :vmodel="uniqueFilter[process.id].testID"
                              :label="'Assessment Name:'"
                            />
                          </div>
                          <div class="topDiv mt-2">
                            <SelectCustom
                              :from="'scroll-filter'"
                              :placeholder="'Select'"
                              :id="'kanban-unique'"
                              type="filter"
                              :values="getFilterOptions(process)"
                              :dropdown="true"
                              @select-value="
                                (uniqueFilter[process.id].filterType = $event),
                                  $forceUpdate()
                              "
                              :vmodel="uniqueFilter[process.id].filterType"
                              :label="'Status:'"
                            />
                          </div>
                          <div @click.stop="" class="topDiv mt-2">
                            <DateField
                              format="YYYY-MM-DD"
                              type="date"
                              :from="'kanban-unique'"
                              :vmodel="uniqueFilter[process.id].dateRange"
                              :label="'Date:'"
                              placeholder="Date"
                              :range="true"
                              @select-value="
                                (uniqueFilter[process.id].dateRange = $event),
                                  $forceUpdate()
                              "
                            />
                          </div>
                        </template>
                        <div
                          class="d-flex justify-content-between mt-3 bluebtn"
                        >
                          <b-button
                            class="acs-cancelBtn-filter"
                            @click="cancelUniqueFilter(process, index)"
                            >Cancel</b-button
                          >
                          <div class="d-flex">
                            <b-button
                              class="acs-cancelBtn-filter mr-3"
                              @click="resetUniqueFilter(process, index)"
                              >Reset</b-button
                            >
                            <b-button
                              :disabled="
                                !uniqueFilter[process.id].filterApplied &&
                                (uniqueFilter[process.id].filterType == '0' ||
                                  uniqueFilter[process.id].filterType == '') &&
                                !uniqueFilter[process.id].testID &&
                                (!uniqueFilter[process.id].dateRange ||
                                  uniqueFilter[process.id].dateRange.length ==
                                    0)
                              "
                              class="acs-cancelBtn-filter"
                              @click="applyUniqueFilter(process, index)"
                              >Apply</b-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div
                    v-if="uniqueFilter[process.id].showFilter"
                    class="allocateradios kanban-more-option-card p-2"
                    style="z-index: 1; width: 270px"
                  >
                    <div class="kanban-filter-heading mb-2">Filter By</div>
                    <template v-if="process.type == 'assesment'">
                    <b-form-group>
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="uniqueFilter[process.id].filterType"
                        :options="getAssessFilterOptions(process.id)"
                        @change="$forceUpdate()"
                        name="radio-options"
                        stacked
                      ></b-form-radio-group>
                    </b-form-group>
                    <div class="topDiv mt-2 w-100" v-if="process.selectedtests.length > 1">
                        <SelectCustom
                          :from="'scroll-filter'"
                          :placeholder="'Select test'"
                          type="filter"
                          :values="testData(process)"
                          :dropdown="true"
                          @select-value="uniqueFilter[process.id].testID = $event, $forceUpdate()"
                          :vmodel="uniqueFilter[process.id].testID"
                          :label="'Test'"
                        />
                      </div>
                    </template>
                    <b-form-group v-else>
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="uniqueFilter[process.id].filterType"
                        :options="scheduleFilterOptions(process.id)"
                        @change="$forceUpdate()"
                        name="radio-options"
                        stacked
                      ></b-form-radio-group>
                    </b-form-group>
                    <div
                      class="w-100 d-flex justify-content-between mt-4 bluebtn"
                    >
                      <div>
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="cancelUniqueFilter(process, index)"
                          >Cancel</b-button
                        >
                      </div>
                      <div class="d-flex">
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="resetUniqueFilter(process, index)"
                          >Reset</b-button
                        >
                        <b-button
                          :disabled="
                            !uniqueFilter[process.id].filterApplied &&
                            (uniqueFilter[process.id].filterType == '0' ||
                              uniqueFilter[process.id].filterType == '') && !uniqueFilter[process.id].testID
                          "
                          class="acs-cancelBtn-filter ml-2"
                          @click="applyUniqueFilter(process, index)"
                          >Apply</b-button
                        >
                      </div>
                    </div>
                  </div> -->
                  </div>
                  <div
                    class="kanban-card-header-number"
                    v-if="roundDetails[`round${process.id}`]"
                  >
                    {{ displayTotal(index) }}
                  </div>
                </div>
                <div
                  v-if="showLoader[index]"
                  class="d-flex align-items-center h-80 mt-2"
                >
                  <SmallSpinner />
                </div>
                <template v-else>
                  <div
                    :style="
                      showElement
                        ? 'height: calc(100% - 60px);'
                        : 'height: calc(100vh - 330px);'
                    "
                  >
                    <div
                      class="overflow-auto my-1 h-100"
                      @scroll="onScrollcandidates(index, process, $event)"
                    >
                      <div
                        v-if="
                          roundDetails[`round${process.id}`] &&
                          roundDetails[`round${process.id}`].candidates
                            .length == 0
                        "
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                          flex-column
                        "
                      >
                        <div>
                          <img
                            src="../../assets/img/newvendorflow/emptyround.svg"
                            alt
                          />
                        </div>
                        <div class="emptyround-txt-kanban">
                          {{
                            searchQuery && searchQuery != "Loader"
                              ? `No results for "${searchQuery}"`
                              : "No candidates assigned to this round"
                          }}
                        </div>
                      </div>

                      <div
                        class="px-3 py-2 position-relative"
                        v-for="candidate in roundDetails[`round${process.id}`]
                          .candidates"
                        :key="candidate.candidateID"
                      >
                        <Selected
                          v-if="process.id == 'F'"
                          :triggerReport="triggerReport"
                          @trigger-report-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          :candidate="candidate"
                          :isSchedule="
                            isSchedule ||
                            viewCandidateModal ||
                            showPlatformModal
                          "
                          :jobOnHold="
                            particularJob.onHold ||
                            triggerCVS ||
                            sendScreening ||
                            triggerReport
                          "
                          :selectedID="selectedID"
                          :selectedCandidate="selectedCandidate"
                          :viewCandidateModal="viewCandidateModal"
                          :particularJob="particularJob"
                          :triggerCVS="triggerCVS"
                          :triggerCands="triggerCands"
                          :tagFiltered="
                            filterApplied && storeFilterTags.length != 0
                          "
                          :hoverCand="hoverCand"
                          @show-blur="showBlurCand($event, candidate)"
                          @request-finaldocs="showOnboardingDocs(candidate)"
                          @view-finaldocs="gotoFinalDocs(candidate)"
                          @trigger-cvs-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          @select-cand="selCandidate($event)"
                          @view-candidate="viewCandidate(candidate, $event)"
                          @give-feedback="giveFeedbackModal(candidate, process)"
                          @schedule-interview="
                            scheduleModal(candidate, process)
                          "
                          @on-hold="onHoldModal(candidate)"
                          @not-interested="notIntModal(candidate)"
                          @view-feedback="openHistoryModal(candidate)"
                          @cancel-meeting="cancelMeet(candidate)"
                          @change-position="showAssignModal(candidate)"
                          @show-add-attachment="
                            (showAttachmentInNote = true),
                              addAttachment(candidate)
                          "
                          @show-add-note="
                            (showAttachmentInNote = true),
                              setNoteTags(candidate),
                              addAddNote(candidate)
                          "
                          @update-details="
                            getAllApplications(true),
                              getParticularJob(particularJob.jobID)
                          "
                        />
                        <Onhold
                          v-else-if="process.id == 'H'"
                          :triggerReport="triggerReport"
                          @trigger-report-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          :candidate="candidate"
                          :isSchedule="
                            isSchedule ||
                            viewCandidateModal ||
                            showPlatformModal
                          "
                          :jobOnHold="
                            particularJob.onHold ||
                            triggerCVS ||
                            sendScreening ||
                            triggerReport
                          "
                          :selectedID="selectedID"
                          :selectedCandidate="selectedCandidate"
                          :viewCandidateModal="viewCandidateModal"
                          :particularJob="particularJob"
                          :triggerCVS="triggerCVS"
                          @show-blur="showBlurCand($event, candidate)"
                          :triggerCands="triggerCands"
                          :sendScreening="sendScreening"
                          :tagFiltered="
                            filterApplied && storeFilterTags.length != 0
                          "
                          :hoverCand="hoverCand"
                          @trigger-cvs-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          @request-docs="requestDocs(candidate)"
                          @select-cand="selCandidate($event)"
                          @view-candidate="viewCandidate(candidate, $event)"
                          @not-interested="notIntModal(candidate)"
                          @re-assign="reAssignModal(candidate)"
                          @view-feedback="openHistoryModal(candidate)"
                          @give-onhold-feedback="
                            giveOnHoldFeedback(candidate, process)
                          "
                          @final-action="finalActionModal(candidate, process)"
                          @goto-viewodcs="gotoViewDocs"
                          @show-add-attachment="
                            (showAttachmentInNote = true),
                              addAttachment(candidate)
                          "
                          @show-add-note="
                            (showAttachmentInNote = true),
                              setNoteTags(candidate),
                              addAddNote(candidate)
                          "
                        />
                        <Rejected
                          v-else-if="process.id == 'R'"
                          :triggerReport="triggerReport"
                          @trigger-report-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          :candidate="candidate"
                          :isSchedule="
                            isSchedule ||
                            viewCandidateModal ||
                            showPlatformModal
                          "
                          :jobOnHold="
                            particularJob.onHold ||
                            triggerCVS ||
                            sendScreening ||
                            triggerReport
                          "
                          :selectedID="selectedID"
                          :selectedCandidate="selectedCandidate"
                          :viewCandidateModal="viewCandidateModal"
                          :particularJob="particularJob"
                          :triggerCVS="triggerCVS"
                          :triggerCands="triggerCands"
                          :tagFiltered="
                            filterApplied && storeFilterTags.length != 0
                          "
                          :hoverCand="hoverCand"
                          @show-blur="showBlurCand($event, candidate)"
                          @trigger-cvs-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          @select-cand="selCandidate($event)"
                          @view-candidate="viewCandidate(candidate, $event)"
                          @re-assign="reAssignModal(candidate)"
                          @view-feedback="openHistoryModal(candidate)"
                          @action-modal="openActionModal(candidate, process)"
                          @show-add-attachment="
                            (showAttachmentInNote = true),
                              addAttachment(candidate)
                          "
                          @show-add-note="
                            (showAttachmentInNote = true),
                              setNoteTags(candidate),
                              addAddNote(candidate)
                          "
                          @update-details="
                            getAllApplications(true),
                              getParticularJob(particularJob.jobID),
                              refreshRejectedRound()
                          "
                        />
                        <NotInterested
                          v-else-if="process.id == 'NI'"
                          :triggerReport="triggerReport"
                          @trigger-report-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          :candidate="candidate"
                          :isSchedule="
                            isSchedule ||
                            viewCandidateModal ||
                            showPlatformModal
                          "
                          :jobOnHold="
                            particularJob.onHold ||
                            triggerCVS ||
                            sendScreening ||
                            triggerReport
                          "
                          :selectedID="selectedID"
                          :selectedCandidate="selectedCandidate"
                          :viewCandidateModal="viewCandidateModal"
                          :particularJob="particularJob"
                          :triggerCVS="triggerCVS"
                          :triggerCands="triggerCands"
                          :tagFiltered="
                            filterApplied && storeFilterTags.length != 0
                          "
                          :hoverCand="hoverCand"
                          @show-blur="showBlurCand($event, candidate)"
                          @trigger-cvs-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          @select-cand="selCandidate($event)"
                          @view-candidate="viewCandidate(candidate, $event)"
                          @re-assign="reAssignModal(candidate)"
                          @view-feedback="openHistoryModal(candidate)"
                          @action-modal="openActionModal(candidate, process)"
                          @goto-viewodcs="gotoViewDocs"
                          @show-add-attachment="
                            (showAttachmentInNote = true),
                              addAttachment(candidate)
                          "
                          @show-add-note="
                            (showAttachmentInNote = true),
                              setNoteTags(candidate),
                              addAddNote(candidate)
                          "
                        />
                        <Assessment
                          v-else-if="process.type == 'assesment'"
                          :triggerReport="triggerReport"
                          @trigger-report-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          :candidate="candidate"
                          :isSchedule="
                            isSchedule ||
                            viewCandidateModal ||
                            showPlatformModal
                          "
                          :jobOnHold="
                            particularJob.onHold ||
                            triggerCVS ||
                            sendScreening ||
                            triggerReport
                          "
                          :selectedID="selectedID"
                          :selectedCandidate="selectedCandidate"
                          :viewCandidateModal="viewCandidateModal"
                          :particularJob="particularJob"
                          :process="interviewProcess[1]"
                          :triggerCVS="triggerCVS"
                          :triggerCands="triggerCands"
                          :sendScreening="sendScreening"
                          :tagFiltered="
                            filterApplied && storeFilterTags.length != 0
                          "
                          :hoverCand="hoverCand"
                          @show-blur="showBlurCand($event, candidate)"
                          @trigger-cvs-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          @goto-viewodcs="gotoViewDocs"
                          @select-cand="selCandidate($event)"
                          @request-docs="requestDocs(candidate)"
                          @trigger-assessment="
                            triggerAssessModal(candidate, process)
                          "
                          @not-interested="notIntModal(candidate)"
                          @re-assign="reAssignModal(candidate)"
                          @give-feedback="giveFeedbackModal(candidate, process)"
                          @view-candidate="viewCandidate(candidate, $event)"
                          @view-feedback="openHistoryModal(candidate)"
                          @move-to-final="openMoveToFinal"
                          @change-position="showAssignModal(candidate)"
                          @show-add-attachment="
                            (showAttachmentInNote = true),
                              addAttachment(candidate)
                          "
                          @show-add-note="
                            (showAttachmentInNote = true),
                              setNoteTags(candidate),
                              addAddNote(candidate)
                          "
                        />
                        <FacetoFace
                          v-else-if="process.type == 'f2f'"
                          :triggerReport="triggerReport"
                          @trigger-report-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          :candidate="candidate"
                          :isSchedule="
                            isSchedule ||
                            viewCandidateModal ||
                            showPlatformModal
                          "
                          :jobOnHold="
                            particularJob.onHold ||
                            triggerCVS ||
                            sendScreening ||
                            triggerReport
                          "
                          :selectedID="selectedID"
                          :selectedCandidate="selectedCandidate"
                          :viewCandidateModal="viewCandidateModal"
                          :particularJob="particularJob"
                          :triggerCVS="triggerCVS"
                          :triggerCands="triggerCands"
                          :sendScreening="sendScreening"
                          :tagFiltered="
                            filterApplied && storeFilterTags.length != 0
                          "
                          :hoverCand="hoverCand"
                          @show-blur="showBlurCand($event, candidate)"
                          @trigger-cvs-cand="
                            addCandToTriggerCVS(candidate.candidateID)
                          "
                          @goto-viewodcs="gotoViewDocs"
                          @request-docs="requestDocs(candidate)"
                          @select-cand="selCandidate($event)"
                          @schedule-interview="
                            scheduleModal(candidate, process)
                          "
                          @not-interested="notIntModal(candidate)"
                          @re-assign="reAssignModal(candidate)"
                          @give-feedback="giveFeedbackModal(candidate, process)"
                          @cancel-meeting="cancelMeet(candidate)"
                          @view-candidate="viewCandidate(candidate, $event)"
                          @view-feedback="openHistoryModal(candidate)"
                          @move-to-final="openMoveToFinal"
                          @change-position="showAssignModal(candidate)"
                          @show-add-attachment="
                            (showAttachmentInNote = true),
                              addAttachment(candidate)
                          "
                          @show-add-note="
                            (showAttachmentInNote = true),
                              setNoteTags(candidate),
                              addAddNote(candidate)
                          "
                        />
                      </div>

                      <div class="text-center" v-if="spinners[index]">
                        <b-spinner class="ml-auto"></b-spinner>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <!-- Schedule interview container starts -->
        <transition name="slide">
          <ScheduleInterview
            v-if="isSchedule"
            :candidate="selectedCandidate"
            :particularJob="particularJob"
            :toRound="toRound ? toRound.toString() : toRound"
            :totalNoOfRounds="interviewProcess.length"
            :remarks="recRemarks"
            :creditsExhausted="creditsExhausted"
            :fromAction="fromAction"
            @show-alreadyinterviewed="showAlreadyInterview = true"
            @close-schedule="closeScheduleModal"
            @schedule-success="
              getAllApplications(true), getParticularJob(particularJob.jobID)
            "
          />
        </transition>
        <ViewCandidateApplication
          v-if="openPreview"
          :openPreview="openPreview"
          :candDetails="selectedCandidate"
          :isBuilderProfileAvailable="isBuilderProfileAvailable"
          :customFieldsArray="customFieldsArray"
          :isPending="false"
          @close-review-cand="closeViewCandStatus"
        />
      </template>
    </div>
    <TriggerAssessment
      v-if="trigger"
      :trigger="trigger"
      :selectedCandidate="selectedCandidate"
      :selectedProcess="selectedProcess"
      :particularJob="particularJob"
      :toRound="toRound"
      :remarks="recRemarks"
      @show-alreadyinterviewed="showAlreadyInterview = true"
      @close-modal="closeTriggerModal"
      @update-details="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
    />
    <!-- interview round modal -->
    <ActionModal
      v-if="actionModal"
      :showModal="actionModal"
      :selectedCandidate="selectedCandidate"
      :interviewProcess="interviewProcess"
      :particularJob="particularJob"
      @trigger-action="triggerAction"
      @close-modal="closeActionModal"
      @update-details="getParticularJob(particularJob.jobID)"
    />

    <AlreadyInterviewed
      v-if="showAlreadyInterview"
      :showAlreadyInterview="showAlreadyInterview"
      :vendor="vendor"
      :inAddedToJd="inAddedToJd || !toRound"
      :toRound="
        (!trigger && !toRound) || inAddedToJd
          ? '0'
          : trigger
          ? selectedProcess.id.toString()
          : toRound
          ? toRound.toString()
          : toRound
      "
      :totalNoOfRounds="interviewProcess.length"
      :vendorRounds="vendorRounds"
      :candidate="selectedCandidate"
      :particularJob="particularJob"
      @close-modal="closeAlreadyModal"
    />

    <!-- move to on hold modal -->

    <b-modal
      id="movetoonhold"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="isOnHold"
      @hidden="closeOnHoldModal"
    >
      <div class="w-100">
        <div class="p-3 d-flex justify-content-between align-items-center">
          <div class="pff-modal-heading">
            <span class="mr-2">
              <img src="../../assets/img/newkanban/moveonholdmodal.svg" alt />
            </span>
            Move to On-Hold
          </div>
          <div class="pointer" @click="closeOnHoldModal">
            <img
              class="rotate-on-hover"
              src="../../assets/img/feedbackform/x-close.svg"
              alt
            />
          </div>
        </div>
      </div>
      <hr class="m-0" />
      <div class="p-3">
        <div class="finalselect-modal-txt mt-1">
          Are you sure you want to move this candidate to On-Hold?
        </div>
        <div
          class="
            schedint-panelist-info-container
            d-flex
            align-items-center
            mt-3
          "
        >
          <div class="w-10 text-center" v-if="selectedCandidate.customFields">
            <div
              v-if="
                selectedCandidate.customFields &&
                selectedCandidate.customFields.imageMedia &&
                selectedCandidate.customFields.imageMedia != null
              "
              class="kanban-maincard-dp"
            >
              <img
                class="w-100 h-100"
                :src="selectedCandidate.customFields.imageMedia"
                alt
              />
            </div>

            <div
              class="
                kanban-maincard-dp-text
                d-flex
                justify-content-center
                align-items-center
              "
              v-else
            >
              {{ selectedCandidate.name[0].toUpperCase() }}
            </div>
          </div>
          <div class="w-40 text-truncate">{{ selectedCandidate.name }}</div>
          <div class="w-50 text-truncate">{{ selectedCandidate.email }}</div>
        </div>
        <div class="newmodalinputbox mt-3">
          <div class="jdk-ip-confirm-subtxt">
            Remarks
            <span class="asterik">*</span>
          </div>
          <b-form-textarea
            rows="2"
            type="text"
            max-rows="5"
            placeholder="Enter"
            v-model="remarks"
            :class="$v.remarks.$error ? 'error' : ''"
          ></b-form-textarea>
          <div v-if="$v.remarks.$error" class="errortxt position-absolute">
            Required
          </div>
        </div>
      </div>
      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          p-2
          bluebtn
          mt-2
          mb-2
        "
      >
        <b-button
          class="acs-cancelBtn-modal w-105px mr-3"
          @click="closeOnHoldModal()"
          >Cancel</b-button
        >
        <b-button class="acs-addBtn-modal w-105px" @click="confirmOnHold()"
          >Confirm</b-button
        >
      </div>
    </b-modal>

    <!-- final selection modal -->
    <b-modal
      id="finalselectmodal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      size="md"
      :visible="isFinalAction"
      @hidden="closeFinalSelectModal()"
    >
      <div class="w-100">
        <div class="p-3 d-flex justify-content-between align-items-center">
          <div class="pff-modal-heading">Final Selection</div>
          <div class="pointer" @click="closeFinalSelectModal()">
            <img
              class="rotate-on-hover"
              src="../../assets/img/feedbackform/x-close.svg"
              alt
            />
          </div>
        </div>
      </div>
      <hr class="m-0" />
      <div class="p-3">
        <div class="finalselect-modal-txt mt-1">
          This candidate was already selected and then moved to
          <br />on-hold. So now you can select or reject the candidate .
        </div>
        <div class="allocateradios d-flex align-items-ce nter mt-3">
          <b-form-radio :value="true" v-model="finalSelect"
            >Select</b-form-radio
          >
          <b-form-radio :value="false" v-model="finalSelect" class="ml-3"
            >Reject</b-form-radio
          >
        </div>
        <div
          class="
            schedint-panelist-info-container
            d-flex
            align-items-center
            mt-3
          "
        >
          <div class="w-10 text-center" v-if="selectedCandidate.customFields">
            <div
              v-if="
                selectedCandidate.customFields.imageMedia &&
                selectedCandidate.customFields.imageMedia != null
              "
              class="kanban-maincard-dp"
            >
              <img :src="selectedCandidate.customFields.imageMedia" alt />
            </div>

            <div
              class="
                kanban-maincard-dp-text
                d-flex
                justify-content-center
                align-items-center
              "
              v-else
            >
              {{ selectedCandidate.name[0].toUpperCase() }}
            </div>
          </div>
          <div class="w-40 text-truncate">{{ selectedCandidate.name }}</div>
          <div class="w-50 text-truncate">{{ selectedCandidate.email }}</div>
        </div>
      </div>

      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          p-2
          bluebtn
          mt-2
          mb-2
        "
      >
        <b-button
          class="acs-cancelBtn-modal w-105px mr-3"
          @click="finalLoader ? '' : closeFinalSelectModal()"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal w-105px"
            :class="
              finalLoader ? 'confirm-loader-class defaultCursor' : 'pointer'
            "
            @click="confirmFinalAction()"
            >{{ finalLoader ? "" : "Confirm" }}</b-button
          >
          <div
            v-if="finalLoader"
            :class="
              selectedCandidate.kanbanScheduled
                ? 'confirm-loader-pos'
                : 'confirm-loader-pos'
            "
          >
            <Loader />
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="warningmodal"
      centered
      hide-footer
      no-close-on-backdrop
      hide-header
      :visible="isWarning"
      @hidden="isWarning = false"
    >
      <div class="d-flex">
        <div class="mr-3">
          <img src="@/assets/talentpool/yellowWarning.svg" alt />
        </div>
        <div>
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Warning</div>
            <div @click="isWarning = false">
              <img
                class="rotate-on-hover"
                src="@/assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1">
            Your credit limit is low. Please add more credits to keep the
            automated job process running.
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button class="acs-cancelBtn-modal mr-3" @click="isWarning = false">{{
          roles.includes("HIRE3X_WALLET") ? "Later" : "Close"
        }}</b-button>
        <div v-if="roles.includes('HIRE3X_WALLET')" class="position-relative">
          <b-button @click="goToCredits()" class="acs-addBtn-modal pointer"
            >Add Now</b-button
          >
        </div>
      </div>
    </b-modal>

    <!-- move to not interested modal -->

    <NotInterestedModal
      v-if="isNotInterested"
      :isNotInterested="isNotInterested"
      :selectedCandidate="selectedCandidate"
      :particularJob="particularJob"
      @close-modal="closeNotinterestedModal"
      @update-details="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
    />

    <!-- Reassign modal -->
    <Reassign
      v-if="isReassign"
      :type="isScreening ? true : false"
      :showModal="isReassign"
      :selectedCandidate="selectedCandidate"
      :screeningCands="triggerCands"
      :particularJob="particularJob"
      @hide-screening="closeScreening"
      @update-details="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
      @close-modal="closeAssignRec"
    />

    <!-- give feedback modal -->
    <GiveFeedBack
      v-if="isGiveFeedback"
      :isGiveFeedback="isGiveFeedback"
      :selectedProcess="selectedProcess"
      :selectedCandidate="selectedCandidate"
      :particularJob="particularJob"
      :totalNoOfRounds="interviewProcess.length"
      @close-modal="closeGiveFeedback"
      @storeCandidateData="storeCandidateData(), storeProcessData()"
      @update-details="getParticularJob(particularJob.jobID)"
    />

    <AddFromTalentPool
      v-if="showTalentPool"
      :showTalentPool="showTalentPool"
      :particularJob="particularJob"
      :positionIDs="positionIDs"
      @view-candidate="selectCand"
      @add-cand-job="showAddCand"
      @close-modal="handleTalentPoolClose"
    />

    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :selectedCandidate="selectedCandidate"
      :showNote="true"
      :jobOnHold="particularJob.onHold"
      :singleJob="particularJob"
      :openReportTab="openReportTab"
      :showNoteTag="showNoteTag"
      @goto-viewodcs="gotoViewDocs"
      @close-view-icon="closeViewIcon"
      @get-cand-data="getSingleRowData(selectedCandidate)"
      @add-note="(noteTagData = $event), addAddNote()"
    />

    <FeedbackHistory
      v-if="showHistoryModal"
      :candidateID="selectedCandidate.candidateID"
      :jobID="particularJob.jobID"
      :showModal="showHistoryModal"
      :candidateData="selectedCandidate"
      @hideFeedbackhistory="hideFeedbackhistory"
      @storeCandidateData="storeCandidateData"
    />
    <TriggerMultipleAssessment
      v-if="showMultiTrigger"
      :showMultiTrigger="showMultiTrigger"
      :process="selectedProcess"
      :particularJob="particularJob"
      :level="level"
      :viewCandID="viewCandID"
      @view-candidate="selectCand"
      @trigger-success="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
      @close-multi-trigger="closeMultipleTrigger"
    />

    <!-- cancel Meeting -->
    <CancelMeetingModal
      v-if="showCancelMeeting"
      :candidate="selectedCandidate"
      :particularJob="particularJob"
      :showCancelMeeting="showCancelMeeting"
      @cancel-success="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
      @close-cancel="closeCancelMeeting"
    />

    <AddMultipleExcelModal
      :context="this"
      :particularJob="particularJob"
      @update-talent-pool="
        closeModals(),
          getAllApplications(true),
          getParticularJob(particularJob.jobID)
      "
      :addMultipleCandidates="addMultipleCandidates"
      v-if="addMultipleCandidates"
      @input="handleAddCandidates"
      :checkMultiple="checkMultiple"
      :multiExcelCands="multiExcelCands"
      @stop-spinner="stopSpinner"
      @show-add-candidate="showAddCand"
      @closeExcel="handleCloseMultple"
      @close-jd-modals="closeModals()"
      @closeAddedMultipleExcelCand="handleAdd"
    />

    <AssessmentExpiredModal
      v-if="showExpired"
      :showExpired="showExpired"
      :jobID="particularJob.jobID"
      @close-expired="showExpired = false"
    />

    <MoveToFinal
      v-if="isMoveToFinal"
      :isMoveToFinal="isMoveToFinal"
      :selectedProcess="selectedProcess"
      :selectedCandidate="selectedCandidate"
      :particularJob="particularJob"
      @close-modal="closeMoveToFinal"
      @update-details="getParticularJob(particularJob.jobID)"
    />
    <AddAttachment
      v-if="showAddAttachment"
      :showAddAttachment="showAddAttachment"
      :uploadingResume="uploadingResume"
      :candidateID="selectedCandidate.candidateID"
      :jobID="particularJob.jobID"
      :email="selectedCandidate.email"
      @close-modal="closeAttachment"
      @update-details="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
      @show-add-note="setNoteTags(selectedCandidate), addAddNote()"
    />

    <AddNote
      v-if="showAddNote"
      :showAttachmentInNote="showAttachmentInNote"
      :viewCandidateModal="viewCandidateModal ? false : true"
      :showAddNote="showAddNote"
      :candidateID="selectedCandidate.candidateID"
      :jobID="particularJob.jobID"
      :noteTagData="noteTagData"
      @close-modal="closeAddNote"
      @refresh-round="getSingleRowData(selectedCandidate)"
      @show-add-attachment="addAttachment()"
    />

    <AssignSinglePositionID
      v-if="showSingleAssign"
      :showSingleAssign="showSingleAssign"
      :positionAssignType="positionAssignType"
      :positionIDs="positionIDs"
      :candidate="items[0]"
      :failure="failure"
      :leadPositions="
        particularJob.leadAssignedPositions
          ? particularJob.leadAssignedPositions
          : []
      "
      @change-failure="failure = false"
      @add-to-job="addSingleCand"
      @update-data="
        getAllApplications(true), getParticularJob(particularJob.jobID)
      "
      @close-modal="closeSingleAssign"
    />

    <AddCandidatesToJob
      v-if="showAddCands"
      :showAddCands="showAddCands"
      :failure="failure"
      @change-failure="
        !showSingleAssign && !showAssignPositionIDs ? (failure = false) : ''
      "
      @go-to-position="gotoPosition"
      @close-modal="closeAddCandidates"
    />

    <AssignPositionID
      v-if="showAssignPositionIDs"
      :showAssignPositionIDs="showAssignPositionIDs"
      :items="items"
      :failure="failure"
      :positionIDOptions="positionIDOptions"
      @change-failure="failure = false"
      @set-position="setPosition"
      @add-cand-to-job="addSingleCand"
      @close-modal="closeAssignPositionIDs"
    />

    <!-- trigger cvs success modal -->
    <ReassignModal
      v-if="showReassignModal"
      :reassignedDetails="cvsSuccessDetails"
      :showReassignModal="showReassignModal"
      :jobName="particularJob.title"
      @hide-screening="closeScreening"
      @handle-close="closeTiggerCVSSuccessModal"
    />

    <RequestDocs
      v-if="showRequestDocs"
      :candidate="selectedCandidate"
      :jobID="particularJob.jobID"
      :showRequestDocs="showRequestDocs"
      @update-details="getCandidates('F', interviewProcess.length - 4)"
      @close-modal="hideOnboardingDocs"
    />

    <!-- Hire3x Platform Suggestions sidebar -->
    <div class="hire3x-sidebar">
      <b-sidebar
        id="platformModal"
        right
        shadow
        v-model="showPlatformModal"
        @hide="handlePlatformModalHide"
        @hidden="handlePlatformModalHidden"
      >
        <header>
          <div class="d-flex align-items-baseline justify-content-between p-3">
            <div
              class="position-absolute pointer newJD-backArrow"
              @click="closePlatformModal"
            >
              <img src="../../assets/img/accessconnew/boxBackArrow.svg" alt />
            </div>
            <div class="newJD-heading ml-4 pt-1">
              Hire3x Platform Suggestions
            </div>
            <div class="d-flex align-items-center">
              <!-- opacity-03 use this class wen disabled to the below div -->
              <div
                class="
                  fw-600
                  fs-13
                  color-mainblue
                  font-mont
                  d-flex
                  align-items-center
                  pointer
                "
                :class="{
                  'disabled-kanban-img':
                    selSuggestCand.length === 0 || suggestLoading,
                }"
                @click="
                  selSuggestCand.length > 0 && !suggestLoading && addtoJob()
                "
              >
                <img
                  src="../../assets/img/plusblue.svg"
                  class="mr-1"
                  style="margin-top: -3px"
                  alt=""
                />
                Add to Job
              </div>
              <div class="sugg-divider mx-3"></div>
              <div class="rotate-on-hover pointer" @click="closePlatformModal">
                <img
                  v-b-tooltip.hover.top="'Close'"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
            </div>
          </div>
        </header>
        <hr class="my-0" />
        <body>
          <section class="platform-main">
            <div
              class="h-100 overflow-auto p-3"
              id="suggestioncontainer"
              @scroll="onScrollSuggestedCandidates($event)"
            >
              <b-card
                class="platform-container w-100 d-flex align-items-center mt-3"
                v-for="(candidate, ind) in suggestedCandidates"
                :key="candidate.candidateID || ind"
              >
                <div class="d-flex align-items-center w-100">
                  <div class="common-single-checkbox">
                    <b-form-checkbox
                      :value="candidate.candidateID"
                      v-model="selSuggestCand"
                    ></b-form-checkbox>
                  </div>
                  <div>
                    <div
                      class="ml-1 mb-1 suggest-icons"
                      :class="
                        candidate.customFields &&
                        candidate.customFields.imageMedia &&
                        candidate.customFields.imageMedia != null
                          ? 'common-sm-profile-transparet-icon'
                          : 'common-sm-profile-icon'
                      "
                    >
                      <b-avatar
                        v-if="
                          candidate.customFields &&
                          candidate.customFields.imageMedia &&
                          candidate.customFields.imageMedia != null
                        "
                        :src="candidate.customFields.imageMedia"
                      ></b-avatar>
                      <b-avatar
                        v-else
                        :text="getAvatarText(candidate.name)"
                      ></b-avatar>
                    </div>
                  </div>
                  <div class="ml-3 w-100">
                    <div
                      class="
                        w-100
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <div class="platform-container-head">
                        {{ candidate.name }}
                      </div>
                      <div class="d-flex align-items-center">
                        <div
                          class="ml-2 pointer"
                          @click="viewSuggestedCandidate(candidate)"
                        >
                          <img
                            src="../../assets/new-kanban-icons/eye-icon.svg"
                            alt
                          />
                        </div>
                        <!-- <div
                          class="
                            ml-2
                            pointer
                            main-share-txt
                            d-flex
                            align-items-center
                            gap-2
                          "
                        >
                          <div class="share-hv">
                            <img
                              src="../../assets/new-kanban-icons/Job-icon.svg"
                              alt
                            />
                          </div>
                          <div
                            class="
                              share-txt
                              d-flex
                              align-items-center
                              justify-content-center
                            "
                          >
                            Add to Job
                            <img
                              class="ml-2"
                              src="../../assets/new-kanban-icons/white-job-icon.svg"
                              alt
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>

                    <div class="platform-container-subhead">
                      <img src="../../assets/img/newkanban/mail.svg" alt />
                      {{ candidate.email }}
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="
                          platform-container-subhead
                          d-flex
                          align-items-center
                        "
                      >
                        <img src="../../assets/img/newkanban/phone.svg" alt />
                        {{ candidate.phoneNumber }}
                      </div>
                      <div class="suggested-pill">Suggested</div>
                    </div>
                  </div>
                </div>
              </b-card>
              <div class="text-center my-3" v-if="showSuggestLoader">
                <b-spinner class="ml-auto"></b-spinner>
              </div>
            </div>
          </section>
        </body>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import KanbanMixin from "../../components/mixin/kanbanMixin";
import AddedByUsers from "../../components/fixedcomponents/TalentPool/AddedByUsers.vue";
import { required } from "vuelidate/lib/validators";
import {
  selectedToOnHold,
  actionOnFinalHold,
  allCandidatestoJD,
  funnelApi,
  getJobApplicationStats,
  getRoundDetails,
  trigerCvs,
  addtojd,
  reAnalyzeResume,
  triggerResumeReport,
  exportKanbanCands,
  getCandRanking,
  moveToFirst,
  getCreditsInfo,
  getTalentPoolMatches,
} from "../../utils/apiFunctions";
import Loader from "../../components/fixedcomponents/Loader.vue";
import Application from "../../components/Kanban/Application.vue";
import ViewCandidateApplication from "../../components/Kanban/ViewCandidateApplication.vue";
import { mapGetters } from "vuex";
import Reassign from "../../components/Kanban/modal/Reassign.vue";
import AssignSinglePositionID from "../../components/Kanban/modal/AssignSinglePositionID.vue";
import AddCandidatesToJob from "../../components/Kanban/modal/AddCandidatesToJob.vue";
import AssignPositionID from "../../components/Kanban/modal/AssignPositionID.vue";
import RequestDocs from "@/components/Kanban/modal/RequestDocs.vue";
import { funnelChart } from "vue-d3-charts-hire3x";
import ReassignModal from "../../controllers/JD/modals/ReassignModal.vue";
export default {
  data() {
    return {
      showPlatformModal: false,
      fromSuggestedSidebar: false,
      suggestLoading: false,
      showSuggestLoader: false,
      suggestPage: 0,
      suggestCount: 20,
      suggestTotal: 0,
      suggestPageEnd: 0,
      selSuggestCand: [],
      suggestedCandidates: [],
      sendScreening: false,
      screening: false,
      availableCredits: null,
      creditThreshold: 10000,
      interviewCost: null,
      isExists: false,
      isNew: false,
      cvs: false,
      triggerCVS: false,
      triggerCVSPost: false,
      report: false,
      triggerReport: false,
      triggerReportPost: false,
      warnClose: false,
      // design variables start
      sorted: null,
      sortDesc: false,
      cvsStatusValues: [
        { key: "3", label: "All" },
        { key: "1", label: "Triggered" },
        { key: "0", label: "Not Triggered" },
        { key: "2", label: "Submitted" },
      ],
      fields: [
        { key: "name", label: "Candidate Name", sortable: true },
        { key: "positionID", label: "Position ID" },
      ],
      items: [],
      positionIDs: [],
      positionIDOptions: [],
      cvsSuccessDetails: {
        alreadyExisting: [],
        newlyAdded: [],
      },
      isScreening: false,
      isWarning: false,
      showReassignModal: false,
      // design variables end
      showSingleAssign: false,
      showAddCands: false,
      showAssignPositionIDs: false,
      positionAssignType: null,
      funnelLoader: true,
      isJobDropdown: false,
      addCandidateToggle: false,
      thirdParty: false,
      isOnHold: false,
      isFinalAction: false,
      failure: false,
      isBuilderProfileAvailable: false,
      remarks: "",
      applFilter: "",
      storeApplFilter: "",
      appTotal: null,
      appPageEnd: null,
      applPage: 0,
      finalSelect: true,
      finalLoader: false,
      applFilterApplied: false,
      showApplFilter: false,
      showApplLoader: false,
      applSpinner: false,
      openPreview: false,
      showRequestDocs: false,
      applications: [],
      positionFilters: [],
      totalApplications: null,
      applFilterOptions: [
        { text: "All", value: "" },
        { text: "Not Yet Approved", value: "0" },
        { text: "Rejected", value: "2" },
      ],
      jobStatsData: {},
      jobStats: {},
      applicationData: {},
      triggerCands: [],
      multiExcelCands: {},
    };
  },
  components: {
    AddedByUsers,
    Loader,
    Application,
    ViewCandidateApplication,
    Reassign,
    AssignSinglePositionID,
    AddCandidatesToJob,
    AssignPositionID,
    ReassignModal,
    RequestDocs,
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      getCustomerDetail: "getCustomerDetail",
    }),
    ...mapGetters({ roles: "roles" }),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    displayApplTotal() {
      if (this.applications.length < 0) {
        return "0" + this.applications.length;
      }
      return this.applications.length;
    },
    checkThirdPartyAccess() {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "hire3xcvsearch"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    lowCredits() {
      if (this.availableCredits == 0) return true;
      else {
        return (
          this.availableCredits && this.availableCredits < this.creditThreshold
        );
      }
    },
    creditsExhausted() {
      if (this.availableCredits == 0 && this.interviewCost > 0) return true;
      else {
        return (
          this.availableCredits && this.availableCredits < this.interviewCost
        );
      }
    },
  },
  validations: {
    remarks: {
      required,
    },
  },
  mixins: [KanbanMixin],
  async created() {
    await this.getAllApplications();
    await this.getTalentPoolMatches();
  },
  mounted() {
    document.body.addEventListener("mousedown", this.handleClose);
  },
  beforeDestroy() {
    document.body.removeEventListener("mousedown", this.handleClose);
  },
  watch: {
    applyContainers(newvalue, oldvalue) {
      if (oldvalue && !newvalue) {
        setTimeout(() => {
          this.scrollToLeft(); // hide the element after the animation is complete
        }, 500);
      }
    },
    jobAnalytics(newValue) {
      if (newValue) {
        this.showElement = true;
      } else {
        this.showElement = true; // don't hide the element yet
        setTimeout(() => {
          this.showElement = false; // hide the element after the animation is complete
        }, 1000); // adjust the timeout to match the animation duration
      }
    },
    showPlatformModal(newVal, oldVal) {
      if (oldVal && !newVal && !this.fromSuggestedSidebar) {
        this.selSuggestCand = [];
      }
      if (newVal) {
        this.scrollToTop();
      }
    },
    "$route.query.jobID"(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getTalentPoolMatches();
      }
    },
  },
  methods: {
    openPlatformModal() {
      this.showPlatformModal = true;
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
    scrollToTop() {
      const scrollContainer = document.getElementById("suggestioncontainer");
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
      const sidebarBody = document.querySelector(
        "#platformModal .b-sidebar-body"
      );
      if (sidebarBody) {
        sidebarBody.scrollTop = 0;
      }
    },
    async getTalentPoolMatches(isScroll = false) {
      try {
        if (!isScroll) {
          this.suggestPage = 0;
        }
        const jobID =
          this.$route.query.jobID ||
          (this.particularJob && this.particularJob.jobID);
        const payload = {
          jobID: jobID,
          count: this.suggestCount,
          page: this.suggestPage,
          type: "1",
          vendor: false,
        };
        const res = await getTalentPoolMatches(payload);
        if (res && res.status === 200) {
          const resData = res.data && res.data.data ? res.data.data : {};
          let candidateList = Array.isArray(resData.data) ? resData.data : [];

          if (this.suggestPage === 0) {
            this.suggestedCandidates = candidateList;
          } else {
            this.suggestedCandidates = [
              ...this.suggestedCandidates,
              ...candidateList,
            ];
          }

          if (resData && resData.pageEnd !== undefined) {
            this.suggestPageEnd = resData.pageEnd;
          } else if (res.data && res.data.pageEnd !== undefined) {
            this.suggestPageEnd = res.data.pageEnd;
          } else {
            this.suggestPageEnd = this.suggestedCandidates.length;
          }

          if (resData && resData.total !== undefined) {
            this.suggestTotal = resData.total;
          } else if (res.data && res.data.total !== undefined) {
            this.suggestTotal = res.data.total;
          } else {
            this.suggestTotal =
              candidateList.length === this.suggestCount
                ? this.suggestedCandidates.length + 1
                : this.suggestedCandidates.length;
          }
        }
      } catch (error) {
        console.error("Error fetching talent pool matches:", error);
      } finally {
        this.showSuggestLoader = false;
        this.$forceUpdate();
      }
    },
    onScrollSuggestedCandidates(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight - 2
      ) {
        if (
          this.checkbetween(this.suggestPageEnd, 0, this.suggestTotal) &&
          !this.showSuggestLoader
        ) {
          this.showSuggestLoader = true;
          this.$forceUpdate();
          this.suggestPage++;
          this.getTalentPoolMatches(true);
        }
      }
    },
    closePlatformModal() {
      this.scrollToTop();
      this.showPlatformModal = false;
      this.selSuggestCand = [];
    },
    handlePlatformModalHide() {
      this.scrollToTop();
    },
    handlePlatformModalHidden() {
      this.showPlatformModal = false;
      if (!this.fromSuggestedSidebar) {
        this.selSuggestCand = [];
      }
      this.scrollToTop();
    },
    getAvatarText(name) {
      if (!name || typeof name !== "string") return "";
      const trimmed = name.trim();
      if (!trimmed) return "";
      const words = trimmed.split(/\s+/).filter(Boolean);
      if (words.length > 1 && words[0] && words[1]) {
        return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
      }
      return trimmed.slice(0, 2).toUpperCase();
    },
    viewSuggestedCandidate(candidate) {
      this.fromSuggestedSidebar = true;
      this.showPlatformModal = false;
      this.selectedID = "";
      this.selectedCandidate = candidate;
      this.showNoteTag = false;
      this.openReportTab = false;
      this.viewCandidateModal = true;
    },
    closeViewIcon(showNote) {
      if (showNote && this.selectedCandidate) {
        this.hoverCand = this.selectedCandidate.candidateID;
      }
      this.viewCandID = "";
      this.viewCandidateModal = false;
      if (this.fromSuggestedSidebar) {
        this.showPlatformModal = true;
        this.fromSuggestedSidebar = false;
      }
    },
    addtoJob() {
      if (!this.selSuggestCand.length) return;
      const selCandData = this.suggestedCandidates.filter((obj) =>
        this.selSuggestCand.includes(obj.candidateID)
      );
      if (this.positionIDs.length > 1) {
        this.showAddCand(selCandData);
      } else {
        this.addToJD("automatic");
      }
    },
    async addToJD(type) {
      this.suggestLoading = true;
      try {
        let jobID = [];
        jobID.push(this.$route.query.jobID || this.particularJob.jobID);
        const data = {
          candidateIDs: this.selSuggestCand,
          jobIDs: jobID,
        };
        if (type) data[type] = true;
        const response = await addtojd(data);
        if (response.status === 200) {
          this.suggestLoading = false;
          this.showPlatformModal = false;
          let text;
          if (this.selSuggestCand.length == 1) {
            text = "Candidate added successfully!";
          } else {
            text = "Candidates added successfully!";
          }
          this.selSuggestCand = [];
          this.handleTalentPoolClose("candadded");
          this.getTalentPoolMatches();
          this.$nextTick(() => {
            this.dynamicToast("success", `Successfully added`, text);
          });
        } else {
          this.suggestLoading = false;
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.suggestLoading = false;
        this.errorModal("Something went wrong!");
        this.selSuggestCand = [];
      }
    },
    handleClose(event) {
      if (!event) return;
      if (
        this.$refs.closeCard &&
        !this.$refs.closeCard?.contains(event.target) &&
        !this.$refs.openCard?.contains(event.target) &&
        !document
          .getElementsByClassName("mx-calendar")[0]
          ?.contains(event.target) &&
        !document
          .getElementsByClassName("mx-calendar")[1]
          ?.contains(event.target)
      ) {
        this.isFilter = false;
      }
    },
    gotoFinalDocs(candidate) {
      this.$router.push({
        name: "OnboardingDocuments",
        params: {
          jobID: this.particularJob.jobID,
          candidateID: candidate.candidateID,
        },
        query: this.$route.query,
      });
    },
    showOnboardingDocs(candidate) {
      this.selectedCandidate = candidate;
      this.showRequestDocs = true;
    },
    hideOnboardingDocs() {
      this.showRequestDocs = false;
      this.selectedCandidate = {};
    },
    sendCandForScreening() {
      this.isScreening = true;
      this.isReassign = true;
    },
    async getCreditsInfo() {
      try {
        const res = await getCreditsInfo();
        if (res.status == 200) {
          this.availableCredits = res.data.data.data.availableCredits;
          this.interviewCost = res.data.data.data.interviewCost;
          if (
            this.availableCredits < this.creditThreshold &&
            this.particularJob.automatic
          ) {
            this.isWarning = true;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    goToCredits() {
      // window.open("https://utility.simplifycv.com/login");
      window.open("https://utility.hire3x.com");
    },
    async moveToFirstRound(candidate) {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          candidateID: candidate.candidateID,
        };
        const res = await moveToFirst(payload);
        if (res.status == 200) {
          this.dynamicToast(
            "success",
            `${candidate.name} moved to first round.`,
            ""
          );
          this.applicationData["QA"].applSpinner = true;
          this.applicationData["QA"].applPage = 0;
          this.showLoader[0] = true;
          this.pages[0] = 0;
          this.getCandidates("1", 0);
          this.getCandidatesData("QA");
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        console.error(error);
      }
    },
    async exportCandidates() {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          type: 3,
          lead: this.getCustomerDetail.lead,
        };
        const res = await exportKanbanCands(payload);
        if (res.status == 200) {
          this.dynamicToast("success", "Candidates exported successfully!", "");
          const href = URL.createObjectURL(res.data);
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          const jobName = this.particularJob.title;
          link.href = href;
          link.setAttribute("download", `${jobName}-Candidates.xlsx`);

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
      }
    },
    async reAanalyzeCand(candidateID) {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          candidateID: candidateID,
        };
        const res = await reAnalyzeResume(payload);
        if (res.status == 200) {
          this.dynamicToast("success", res.data.data.Detail, "");
          this.applicationData["RAI"].applSpinner = true;
          this.$forceUpdate();
          this.applicationData["RAI"].applPage = 0;
          this.getCandidatesData("RAI");
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
      }
    },
    async triggerReportCand(candidateID) {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          candidateID: candidateID,
        };
        const res = await triggerResumeReport(payload);
        if (res.status == 200) {
          this.dynamicToast(
            "success",
            "Generating match report",
            "Your detailed report will be ready in a minute."
          );
          this.applicationData["QA"].applSpinner = true;
          this.$forceUpdate();
          this.applicationData["QA"].applPage = 0;
          this.getCandidatesData("QA");
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
      }
    },
    async getCandRanking() {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          lead: this.getCustomerDetail.lead,
        };
        const res = await getCandRanking(payload);
        if (res.status == 200) {
          const rankingData = res.data.data;
          this.roundDetails.roundF.candidates.map(
            (obj) => (obj.ranking = rankingData[obj.candidateID])
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    scrollToLeft() {
      const scrollContainer = document.getElementById("mainkanban");
      scrollContainer.scrollTo({
        left: 0,
        behavior: "smooth", // Smooth scrolling animation
      });
    },
    getRejectedCands() {
      this.applicationData["RAI"].applSpinner = true;
      this.applicationData["QA"].applSpinner = true;
      this.$forceUpdate();
      this.applicationData["RAI"].applPage = 0;
      this.applicationData["QA"].applPage = 0;
      this.getCandidatesData("RAI");
      this.getCandidatesData("QA");
      if (this.particularJob.automatic && !this.particularJob.manualReview) {
        this.showLoader[0] = true;
        this.pages[0] = 0;
        this.getCandidates("1", 0);
      }
    },
    getQualifiedCands() {
      this.applicationData["QA"].applSpinner = true;
      this.$forceUpdate();
      this.applicationData["QA"].applPage = 0;
      this.getCandidatesData("QA");
    },
    refreshRejectedRound() {
      const index = this.interviewProcess.findIndex((p) => p.id === "R");
      if (index === -1) return;
      this.pages[index] = 0;
      this.showLoader[index] = true;
      this.$forceUpdate();
      Promise.all([
        this.getCandidatesData("QA"),
        this.getCandidatesData("RAI"),
        this.getCandidates("R", index),
      ]).then(() => this.getJobStats());
    },
    stopSpinner() {
      this.failure = true;
      this.$forceUpdate();
    },
    checkAndApplyGraph() {
      if (!this.triggerCVS) {
        this.jobAnalytics = !this.showElement;
        if (this.jobAnalytics) this.makeFunnelGraph();
      }
    },
    showSuccessCVS() {
      this.showReassignModal = true;
    },
    async closeTiggerCVSSuccessModal() {
      this.showReassignModal = false;
      this.cvsSuccessDetails = {
        alreadyExisting: [],
        newlyAdded: [],
      };
      this.closeTrigger();
      this.loaderStatus = true;
      await this.getParticularJob(this.particularJob.jobID);
      await this.getAllApplications(true);
    },
    showScreening() {
      if (!this.sendScreening) {
        this.screening = true;
      }
    },
    hideScreening() {
      if (!this.sendScreening) {
        this.screening = false;
      }
    },
    showCVS() {
      if (!this.triggerCVS) {
        this.cvs = true;
      }
    },
    hideCVS() {
      if (!this.triggerCVS) {
        this.cvs = false;
      }
    },
    showReport() {
      if (!this.triggerReport) {
        this.report = true;
      }
    },
    hideReport() {
      if (!this.triggerReport) {
        this.report = false;
      }
    },
    closeReport() {
      this.report = false;
      this.triggerReport = false;
      this.triggerReportPost = false;
      this.triggerCands = [];
      this.$forceUpdate();
    },
    async triggerReportForCands() {
      this.triggerReportPost = true;
      try {
        for (const candidateID of this.triggerCands) {
          let payload = {
            jobID: this.particularJob.jobID,
            customerID: this.particularJob.customerID,
            candidateID: candidateID,
          };
          await triggerResumeReport(payload);
        }
        this.dynamicToast(
          "success",
          "Generating match reports",
          "Your detailed reports will be ready in a minute."
        );
        this.triggerReportPost = false;
        this.closeReport();
        await this.getAllApplications(true);
        await this.getParticularJob(this.particularJob.jobID);
      } catch (error) {
        this.triggerReportPost = false;
        this.errorModal("Something went wrong");
      }
    },
    async triggerCVSForCands() {
      this.triggerCVSPost = true;
      try {
        let payload = {
          candidates: this.triggerCands,
          jobID: this.particularJob.jobID,
        };
        const res = await trigerCvs(payload);
        if (res.status == 200) {
          this.cvsSuccessDetails.alreadyExisting =
            res.data.data.data.oldCandidates;
          this.cvsSuccessDetails.newlyAdded = res.data.data.data.newCandidates;
          this.showSuccessCVS();
          this.triggerCVSPost = false;
        } else {
          this.triggerCVSPost = false;
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.triggerCVSPost = false;
        this.errorModal("Something went wrong!");
        console.error(error);
      }
    },
    addCandToTriggerCVS(candidateID) {
      if (this.triggerCands.includes(candidateID)) {
        let index = this.triggerCands.indexOf(candidateID);
        this.triggerCands.splice(index, 1);
      } else {
        this.triggerCands.push(candidateID);
      }
    },
    closeScreening() {
      this.isScreening = false;
      this.screening = false;
      this.sendScreening = false;
      this.triggerCands = [];
      this.$forceUpdate();
    },
    closeTrigger() {
      this.cvs = false;
      this.triggerCVS = false;
      this.triggerCands = [];
      this.$forceUpdate();
    },
    closeModals() {
      this.closeAssignPositionIDs();
      this.closeSingleAssign();
      this.closeAddCandidates();
    },
    closeAssignPositionIDs() {
      this.showAssignPositionIDs = false;
      this.multiExcelCands = {};
    },
    closeSingleAssign() {
      this.showSingleAssign = false;
      this.multiExcelCands = {};
    },
    addSingleCand(cand) {
      this.items = cand;
      if (this.addMultipleCandidates) {
        this.multiExcelCands = { type: "manual", cands: this.items };
      } else {
        this.addCandsToJob();
      }
    },
    closeAddCandidates() {
      this.showAddCands = false;
    },
    showAssignModal(cand) {
      this.items = [];
      this.items.push(cand);
      this.positionAssignType = "change";
      this.showSingleAssign = true;
    },
    async addCandsToJob(val) {
      try {
        let jobID = [];
        jobID.push(this.particularJob.jobID);
        const data = {
          jobIDs: jobID,
        };
        if (!val) {
          let positionValues = {};
          let candIDs = this.items.map((obj) => {
            positionValues[obj.candidateID] = obj.positionID;
            return obj.candidateID;
          });
          data.positions = positionValues;
          data.candidateIDs = candIDs;
        } else {
          data.candidateIDs = this.items.map((obj) => {
            return obj.candidateID;
          });
          data.automatic = true;
        }
        const response = await addtojd(data);
        if (response.status === 200) {
          this.showSingleAssign = false;
          this.showAddCands = false;
          this.showAssignPositionIDs = false;
          this.showPlatformModal = false;
          this.selSuggestCand = [];
          this.handleTalentPoolClose("candadded");
          this.getTalentPoolMatches();
          let text;
          if (this.items.length == 1) {
            text = "Candidate added successfully!";
          } else {
            text = "Candidates added successfully!";
          }
          this.$nextTick(() => {
            this.dynamicToast("success", `Successfully added`, text);
          });
        } else {
          this.failure = true;
          this.$forceUpdate();
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.failure = true;
        this.$forceUpdate();
        this.errorModal("Something went wrong!");
      }
    },
    setPosition(data) {
      let key = this.addMultipleCandidates ? "email" : "candidateID";
      this.items.map((obj) => {
        if (obj[key] == data.item[key]) {
          obj.positionID = data.value;
        }
      });
      this.$forceUpdate();
    },
    showAddCand(data) {
      this.items = data;
      this.showAddCands = true;
    },
    gotoPosition(value) {
      if (value == 2) {
        if (this.items.length > 1) {
          this.items.forEach((obj) => (obj.positionID = this.positionIDs[0]));
          this.positionIDOptions = this.positionIDs;
          this.showAssignPositionIDs = true;
        } else {
          this.positionAssignType = null;
          this.showSingleAssign = true;
        }
      } else if (this.addMultipleCandidates) {
        this.multiExcelCands = { type: "automatic" };
      } else {
        this.addCandsToJob("automatic");
      }
    },
    async getAllApplications(type) {
      let vals = ["AP", "QA", "RAI"];
      for (let i of vals) {
        if (!type) this.generateKeys(i);
        else this.applicationData[i].applPage = 0;
        this.applicationData[i].applSpinner = true;
      }
      await Promise.all([
        this.getCandidatesData("QA"),
        this.getCandidatesData("RAI"),
        this.getApplications("AP"),
      ]);
      await this.getJobStats();
    },
    generateKeys(key) {
      this.$set(this.applicationData, key, {
        applPage: 0,
        applications: [],
        appTotal: null,
        appPageEnd: null,
        applSpinner: false,
        showApplLoader: false,
      });
    },
    // Filter code starts

    // filter code ends

    // job card code starts
    closeJobCard() {
      this.isJobDropdown = false;
    },
    // jb card code ends

    gotoAnalytics() {
      this.$router.push({
        name: "Analytics",
        query: {
          jobID: this.$route.query.jobID,
          lead: this.getCustomerDetail.lead,
          customerName: this.$route.query.cardName,
          customerID: this.$route.query.customerID,
          jobName: this.particularJob.title,
        },
      });
    },
    gotoviewdocs() {
      this.$router.push({ name: "viewcandidatedocs" });
    },
    goBack() {
      this.$router.push({
        name: `InternalHiringDashboard`,
        query: {
          cardName: this.$route.query.cardName,
          gridView: this.$route.query.gridView,
        },
        params: {
          cardName: this.$route.query.cardName,
          customerID: this.$route.query.customerID,
        },
      });
    },
    hideaddToggle() {
      this.addCandidateToggle = false;
    },

    // filter starts

    // filter ends

    // on hold modal starts

    onHoldModal(candidate) {
      this.selectedCandidate = candidate;
      this.selectedProcess = process;
      this.isOnHold = true;
    },

    closeOnHoldModal() {
      this.selectedCandidate = {};
      this.selectedProcess = {};
      this.remarks = "";
      this.$v.$reset();
      this.isOnHold = false;
    },

    async confirmOnHold() {
      this.$v.remarks.$touch();
      if (!this.$v.$invalid) {
        let payload = {
          candidateID: this.selectedCandidate.candidateID,
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          action: "onHold",
          remarks: this.remarks,
        };
        const res = await selectedToOnHold(payload);
        if (res.status == 200) {
          let candName = this.selectedCandidate.name;
          this.closeOnHoldModal();
          this.$nextTick(() => {
            var text = `Candidate "${candName}" has been moved to on-hold`;
            this.dynamicToast("onhold", `Moved to On-Hold`, text);
          });
          this.getParticularJob(this.particularJob.jobID);
        }
      }
    },
    // on hold modal ends

    // final action modal starts

    finalActionModal(candidate, process) {
      this.selectedCandidate = candidate;
      this.selectedProcess = process;
      this.isFinalAction = true;
    },
    closeFinalSelectModal() {
      this.selectedCandidate = {};
      this.selectedProcess = {};
      this.isFinalAction = false;
    },
    async confirmFinalAction() {
      this.finalLoader = true;
      let payload = {
        customerID: this.particularJob.customerID,
        jobID: this.particularJob.jobID,
        candidateID: this.selectedCandidate.candidateID,
        select: this.finalSelect,
        remarks: "",
      };
      const res = await actionOnFinalHold(payload);
      if (res.status == 200) {
        this.isFinalAction = false;
        this.finalLoader = false;
        this.getParticularJob(this.particularJob.jobID);
        if (!this.finalSelect) {
          this.$nextTick(() => {
            var text = `Candidate "${this.selectedCandidate.name}" has been rejected`;
            this.dynamicToast("rejected", `Successfully Rejected`, text);
          });
        } else {
          this.$nextTick(() => {
            var text = `Candidate "${this.selectedCandidate.name}" has been selected`;
            this.dynamicToast("success", `Successfully selected`, text);
          });
        }
      } else if (res.status == 409) {
        this.finalLoader = false;
        this.errorModal(
          `Candidate "${this.selectedCandidate.name}" has already been selected for other job`
        );
      } else {
        this.finalLoader = false;
        this.errorModal("Something went wrong!");
      }
    },
    // final action modal end

    // get applications starts

    async getApplications(type) {
      let payload = {
        jobID: this.$route.query.jobID,
        sortBy: {
          column: "createdAt",
          order: false,
        },
        searchQueries: this.searchQuery,
        count: 10,
        page: this.applicationData[type].applPage,
        filters: {
          status: ["0"],
          source: this.filterObject.filterSource,
          skills: this.filterObject.skillSets,
          positions: this.filterObject.positionID,
          tags: this.filterObject.tags,
        },
      };
      if (payload.filters.source.length == 0) {
        delete payload.filters.source;
      }
      if (payload.filters.skills.length == 0) {
        delete payload.filters.skills;
      }
      if (
        this.filterObject.cvsStatus != "3" &&
        this.filterObject.cvsStatus != null
      ) {
        payload.filters.cvsStatus = this.filterObject.cvsStatus;
      }
      if (this.filterObject.selectedDate.length != 0) {
        payload.filters.startDate = this.formatYearsDate(
          this.filterObject.selectedDate[0]
        );
        payload.filters.endDate = this.formatYearsDate(
          this.filterObject.selectedDate[1]
        );
      }
      const res = await allCandidatestoJD(payload);
      if (res.status == 200) {
        this.setApplicationData("AP", res.data.data);
        this.$forceUpdate();
      }
    },
    cancelApplicationFilter() {
      this.showApplFilter = false;
    },
    resetApplicationFilter(type) {
      if (this.applFilterApplied || type) {
        this.applFilterApplied = false;
        this.applFilter = "";
        this.storeApplFilter = "";
        this.applicationData[0].applSpinner = true;
        this.getApplications("0");
      }
      this.showApplFilter = false;
    },
    applyApplicationFilter() {
      this.showApplFilter = false;
      this.applFilterApplied = true;
      this.storeApplFilter = this.applFilter;
      this.applicationData[0].applSpinner = true;
      this.getApplications("0");
    },
    showApplicationFilter() {
      this.applFilter = this.storeApplFilter;
      this.showApplFilter = true;
    },
    onScrollApplCandidates(type, e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(
            this.applicationData[type].appPageEnd,
            0,
            this.applicationData[type].appTotal
          ) &&
          !this.applicationData[type].applSpinner &&
          !this.applicationData[type].showApplLoader
        ) {
          this.applicationData[type].showApplLoader = true;
          this.$forceUpdate();
          this.applicationData[type].applPage++;
          if (type == "AP") this.getApplications("AP");
          else if (type == "QA") this.getCandidatesData("QA");
          else if (type == "RAI") this.getCandidatesData("RAI");
        }
      }
    },
    closeViewCandStatus() {
      this.openPreview = false;
    },
    viewApplCandidate(candidate) {
      this.selectedCandidate = candidate;
      this.isBuilderProfileAvailable = candidate.isBuilderProfileAvailable;
      this.openPreview = true;
    },
    // display graph api
    async makeFunnelGraph() {
      if (
        document.getElementById("funnel") &&
        document.getElementById("funnel").innerHTML != ""
      ) {
        document.getElementById("funnel").innerHTML = "";
      }
      this.funnelLoader = true;
      try {
        const payload = {
          jobID: this.$route.query.jobID,
          lead: this.getCustomerDetail.lead,
        };
        const response = await funnelApi(payload);
        if (response.status == 200) {
          this.jobStatsData = response.data.data;
          let originalData = response.data.data.data.splice(1);
          const widthPass = window.innerWidth / 5;
          setTimeout(() => {
            if (document.getElementById("funnel").innerHTML != "") {
              document.getElementById("funnel").innerHTML = "";
            }
            let img1 = require("@/assets/new-kanban-icons/added.svg");
            let img2 = require("@/assets/new-kanban-icons/Group.svg");
            let img3 = require("@/assets/new-kanban-icons/VectorTick.svg");
            let images = [img1, img2, img3];
            let e = new funnelChart();
            let component = "Kanban";
            e.createFunnel(originalData, images, widthPass, component);
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.funnelLoader = false;
    },
    async getJobStats() {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
        };
        if (this.customerDetail.lead) payload.lead = true;
        const res = await getJobApplicationStats(payload);
        if (res.status == 200) {
          typeof res.data.data == "object" && res.data.data.length != 0
            ? (this.jobStats = res.data.data)
            : (this.jobStats = {});
          if (this.jobStats != {}) {
            this.jobStats.rejected = this.applicationData["RAI"].appTotal;
            this.jobStats.qualified = this.applicationData["QA"].appTotal;
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    setApplicationData(type, data) {
      if (this.applicationData[type].applPage == 0) {
        this.applicationData[type].applications = data.data;
      } else {
        this.applicationData[type].applications = [
          ...this.applicationData[type].applications,
          ...data.data,
        ];
      }
      this.applicationData[type].appTotal = data.total;
      this.applicationData[type].appPageEnd = data.pageEnd;
      this.applicationData[type].applSpinner = false;
      this.applicationData[type].showApplLoader = false;
      this.$forceUpdate();
    },
    async getCandidatesData(type) {
      let payload = {
        page: this.applicationData[type].applPage,
        count: 10,
        jobID: this.$route.query.jobID,
        customerID: this.$route.query.customerID,
        sortBy: {
          column: "updatedAt",
          order: -1,
        },
        level: "0",
        filters: {
          skillSets: this.filterObject.skillSets,
          source: this.filterObject.filterSource,
          assessment_state: "",
          addedBy: this.filterObject.createdByUserName,
          positions: this.filterObject.positionID,
          scheduled: "",
          noOfTriggers: "",
          tags: this.filterObject.tags,
        },
        searchQuery: this.searchQuery,
        rejectedByAI: type == "RAI" ? true : false,
        userType: this.customerDetail.lead ? "Lead Recruiter" : "Recruiter",
      };
      if (
        this.filterObject.cvsStatus != "3" &&
        this.filterObject.cvsStatus != null
      ) {
        payload.filters.cvsStatus = this.filterObject.cvsStatus;
      }
      if (this.filterObject.selectedDate.length != 0) {
        payload.filters.startDate = this.formatYearsDate(
          this.filterObject.selectedDate[0]
        );
        payload.filters.endDate = this.formatYearsDate(
          this.filterObject.selectedDate[1]
        );
      }
      const res = await getRoundDetails(payload);
      if (res.status == 200) {
        this.setApplicationData(type, res.data.data);
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style>
#funnel {
  overflow-x: auto;
  overflow-y: hidden;
}
.exc-bluetab {
  font-family: var(--lato);
  font-size: var(--size-16);
  font-weight: var(--weight-B);
  color: var(--bluetheme);
  position: relative;
  height: 48px;
  width: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
}
.exc-blacktab {
  font-family: var(--lato);
  font-size: var(--size-16);
  font-weight: var(--weight-LM);
  color: var(--black);
  position: relative;
  height: 48px;
  width: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
}

.exc-sel-tab {
  position: absolute;
  border-bottom: 4px solid #20639b;
  box-shadow: 0px 4px 8px 0px #0000002b;
  width: 100%;
  height: 4px;
  border-radius: 25px 25px 6px 6px;
  bottom: 0px;
  left: 0px;
}

.exc-seacrh .search-input {
  height: 35px;
  background: #72738e14;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0 10px 0 30px !important;
  width: 100%;
  border: none;
}

.exc-seacrh .search-input:focus {
  background: #72738e14;
}

.exc-seacrh .search-input::placeholder {
  color: #72738e80;
  font-family: var(--montserrat);
  font-size: 14px;
  font-weight: 400;
}

.exc-table-head {
  min-width: 1000px;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "lato", sans-serif;
  background: #20639b1a;
}

.exc-table-body {
  min-width: 1000px;
  max-width: 100%;
  overflow-y: auto;
  height: 88%;
}

.kanban-exc-table-row {
  width: 100%;
  position: relative;
  border-radius: 5px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 10px;
  margin: 8px 0px;
}

.kanban-exc-table-row:hover {
  background: #e7e8f5;
}
.exc-bluebtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #20639b;
  box-shadow: 0px 4px 20px 0px #1a416433;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  color: var(--bluetheme);
}

.exc-redbtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #eb000280;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  color: #eb0002;
}

.exc-greenbtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #038e0080;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-12);
  font-weight: var(--weight-M);
  color: #7a7a7a;
}

.kanban-rec-sel {
  background: #e1eef7;
}

.talentPoolcandidateToggle {
  position: absolute;
  top: 35px;
  right: 0px;
  background: #ffffff;
  box-shadow: 0px 1px 11px 0px #00000061;
  border-radius: 5px;
  padding: 10px;
  z-index: 3;
  width: 240px !important;
}

.talentPoolcandidateToggle .unselOption {
  font-weight: 600;
  font-family: "lato", sans-serif;
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.talentPoolcandidateToggle .unselOption:hover {
  background: #e8eff4;
}

.talentPoolcandidateToggle .selOption {
  font-weight: 600;
  font-family: "lato", sans-serif;
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #e8eff4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
}

.talentpool-thirdparty-unsel {
  color: var(--bluetheme);
  font-weight: var(--weight-M);
  font-family: "lato", sans-serif;
  font-size: var(--size-14);
  padding: 8px;
}

.talentpool-thirdparty-unsel:hover {
  background: #e8eff4;
  border-radius: 4px;
}

.talentpool-thirdparty-sel {
  color: var(--bluetheme);
  font-weight: var(--weight-M);
  font-family: "lato", sans-serif;
  font-size: var(--size-14);
  padding: 8px;
  background: #e8eff4;
  border-radius: 4px;
}

.job-analytics-container {
  height: 220px;
  background-color: #ffffff;
  box-shadow: 0px 0px 14px 0px #c4c4c480;
  border-radius: 5px;
  padding: 6px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.fade-in {
  animation: fadeIn 1.9s;
  opacity: 1;
  display: flex;
  align-items: center;
}

.fade-out {
  animation: fadeOut 1.9s;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.app-container {
  padding: 6px 10px;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-family: var(--lato);
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #8c8c8c;
}

.kanban-card-transition-enter-active {
  transition: all 0.6s ease-in;
}

.kanban-card-transition-enter {
  transform: translateX(-300px);
  opacity: 0;
}

.kanban-card-transition-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.kanban-card-transition-leave-active {
  transition: all 0.8s ease-in;
}

.kanban-card-transition-leave {
  transform: translateX(0);
  opacity: 1;
}

.kanban-card-transition-leave-to {
  transform: translateX(-500px);
  opacity: 1;
}

.kanban-card-transition-enter-active,
.kanban-card-transition-leave-active {
  will-change: transform, opacity;
}

.suggest-cand {
  background: #269c8a;
  border: 1px solid #269c8a;
  border-radius: 5px;
  padding: 5px 8px;
  font-family: var(--lato);
  font-style: italic;
  font-weight: 600;
  font-size: 14px;
  line-height: 27px;
  color: #ffffff;
}

.platformModal-qualified {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: #e1eef7;
  border-radius: 5px 5px 0px 0px;
  font-family: var(--lato);
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #333333;
}

.platform-main {
  height: calc(100vh - 172px);
}

.platform-container .card-body {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
}

.platform-container-head {
  font-family: var(--lato);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #3a3c40;
}

.platform-container-subhead {
  font-family: var(--lato);
  font-weight: 500;
  font-size: 14px;
  color: #3a3c40;
}

.w-60 {
  width: 60%;
}

.w-40 {
  width: 40%;
}

.suggested-pill {
  background: #f6f9fb;
  border-radius: 8px;
  padding: 3px 15px;
  font-family: var(--lato);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #038e00;
}

.addTocandJob-head {
  font-family: var(--lato);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}

.addTocandJob-subhead {
  font-family: var(--montserrat);
  font-style: italic;
  font-weight: 500;
  font-size: 11px;
  line-height: 20px;
  color: #70737b;
}

.set-padding {
  padding: 15px 30px;
}

.set-w-px {
  width: 60px;
}

.gridBlue {
  width: 4px;
  height: 48px;
  border-radius: 3px;
  position: absolute;
  left: -9px;
  top: -10px;
  background: #20639b;
}

.available-font {
  font-family: var(--lato);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #3a3c40;
}

.selected-id {
  background: #20639b;
  color: #ffffff;
}

.available-overflow {
  min-height: auto;
  max-height: 250px;
  overflow: auto;
}

/* modals padding set to 0 */

#assignPositionID .modal-body {
  padding: 0px;
}

#assignPosID .modal-body {
  padding: 0px;
}

/* .main-share-txt {
  transition: all 0.3s ease;
  border-radius: 6px;
  padding: 5px;
  border-radius: 100px;
  white-space: nowrap;
  overflow: hidden;
  width: 30px;
  height: 30px;
}

.main-share-txt:hover {
  width: 110px;
  background: #20639b;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 17px;
  padding: 4px 8px;
  font-family: var(--lato);
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  color: #ffffff;
  text-align: center;
}

.main-share-txt:hover .share-hv {
  display: none;
} */

.share-txt {
  opacity: 0;
  padding-left: 5px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateX(-20px);
}

/* .main-share-txt:hover .share-txt {
  width: 100%;
  opacity: 1;
  transform: translateX(0);
} */

.hire3x-sidebar .b-sidebar.b-sidebar-right {
  top: 75px;
}

.hire3x-sidebar .b-sidebar {
  border-radius: 8px;
  height: calc(100vh - 87px);
  max-height: none;
  width: 40%;
}

.hire3x-sidebar .bg-light {
  background-color: #fff !important;
}

.hire3x-sidebar .b-sidebar > .b-sidebar-header {
  display: none;
}

.hire3x-sidebar .b-sidebar.b-sidebar-right > .b-sidebar-header .close {
  display: none;
}
.main-share-txt {
  transition: all 0.9s ease;
  border-radius: 6px;
  border-radius: 100px;
  white-space: nowrap;
  overflow: hidden;
  width: 40px;
  height: 34px;
}

.screening-share-txt.expanded {
  width: 217px !important;
}

/* "Generate Report" does not fit the 165px default. */
.report-share-txt.expanded {
  width: 215px !important;
}

.main-share-txt.expanded {
  transition: all 0.9s ease;
  width: 165px;
  background: #20639b;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 17px;
  /* padding: 4px 8px; */
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  color: #ffffff;
  text-align: center;
}

.share-hv {
  display: block;
}

.main-share-txt.expanded .share-hv {
  display: none;
}

.share-txt {
  opacity: 0;
  padding-left: 5px;
  transition: opacity 1s ease, transform 0.3s ease;
  transform: translateX(-20px);
}

.main-share-txt.expanded .share-txt {
  width: 100%;
  opacity: 1;
  transform: translateX(0);
}
.reassign-head {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.reassign-head-subead {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.reassign-head-mail {
  font-family: "Lato";
  font-weight: 400;
  font-size: 12px;
  color: #666666;
}

.reassign-main-container {
  background: #f6f9fb;
  border-radius: 6px;
  height: calc(100vh - 450px);
  overflow: auto;
}

.reassign-main-container-head {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
}

.reassign-main-container-subhead {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 11px;
  color: #666666;
}

.reassign-main-container-circle {
  width: 20px;
  height: 20px;
  border: 1px solid #8c8c8c;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #8c8c8c;
  border-radius: 50%;
  text-align: center;
}

/* accordian classes */
.common-accordian-card .card-header {
  background: transparent;
  border-bottom: unset;
}

.common-accordian-card .common-red-accordian-card > .card {
  border: 2px solid #e70016;
  background: #f6f9fb;
}

.common-accordian-card .common-green-accordian-card > .card {
  border: 2px solid #038e00;
  background: #f6f9fb;
}

#triggerCVSSuccess .modal-body {
  padding: 0;
}

.round-btn-set:disabled {
  color: var(--bg-white);
  background-color: var(--bluetheme);
  border: 1px solid var(--bluetheme);
}

.round-btn-set {
  width: 34px;
  height: 34px;
  background: #20639b;
  border-radius: 50%;
  border: unset;
}
.round-btn-set:hover {
  background: #20639b !important;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.round-btn-set:active {
  background: #20639b !important;
}
.round-btn-set:focus {
  background: #20639b !important;
}
.on-hold-box {
  background: rgba(255, 193, 69, 0.12);
  border-radius: 40px;
  font-family: Montserrat;
  font-weight: 600;
  font-style: italic;
  font-size: 14px;
  color: #ffc145;
  padding: 0px 10px;
  height: 26px;
}
.line-row {
  width: 1px;
  height: 30px;
  background: rgba(140, 140, 140, 0.3);
}
.automated-txt {
  font-family: "Lato";
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 0%;
  text-align: center;
}
.sugg-divider {
  width: 18px;
  height: 0px;
  border: 1.5px solid #e9ecef;
  transform: rotate(90deg);
}
.opacity-03 {
  opacity: 0.3;
}
.suggested-card {
  height: 35px;
  background: #269c8a;
  border: 1px solid #269c8a;
  border-radius: 5px;
  padding: 10px 8px;
  cursor: pointer;
}
.suggest-icons {
  height: 48px !important;
  width: 48px !important;
}
</style>
